// sprintf() for JavaScript 0.6
// TODO: remove functionality on next major template rebuild
// Developer note: not recommended for further use - pending removal
function str_repeat(e, t) { for (var r = []; 0 < t; r[--t] = e); return r.join("") } function sprintf() { for (var e, t, r, a, s, n = 0, o = arguments[n++], i = []; o;) { if (t = /^[^\x25]+/.exec(o)) i.push(t[0]); else if (t = /^\x25{2}/.exec(o)) i.push("%"); else { if (!(t = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(o))) throw "Huh ?!"; if (null == (e = arguments[t[1] || n++]) || null == e) throw "Too few arguments."; if (/[^s]/.test(t[7]) && "number" != typeof e) throw "Expecting number but found " + typeof e; switch (t[7]) { case "b": e = e.toString(2); break; case "c": e = String.fromCharCode(e); break; case "d": e = parseInt(e); break; case "e": e = t[6] ? e.toExponential(t[6]) : e.toExponential(); break; case "f": e = t[6] ? parseFloat(e).toFixed(t[6]) : parseFloat(e); break; case "o": e = e.toString(8); break; case "s": e = (e = String(e)) && t[6] ? e.substring(0, t[6]) : e; break; case "u": e = Math.abs(e); break; case "x": e = e.toString(16); break; case "X": e = e.toString(16).toUpperCase() }e = /[def]/.test(t[7]) && t[2] && 0 <= e ? "+" + e : e, a = t[3] ? "0" == t[3] ? "0" : t[3].charAt(1) : " ", s = t[5] - String(e).length - "".length, r = t[5] ? str_repeat(a, s) : "", i.push("" + (t[4] ? e + r : r + e)) } o = o.substring(t[0].length) } return i.join("") }


/*
 ----------------------------
 Core Javascript - Asafisk
 ----------------------------
 1. Global Functions
 2. Page Rendering
 3. URL Manipulation
 4. AJAX Handler
 5. Validation (see also options.js)
 6. Generic form disbling
 7. Specific Pages
 7.1. Homepage
 7.2. Product search
 7.3. Product Page
 7.4. Basket Summary
 7.5. Registration
 7.6. Checkout
 7.7. Site Docs / Forms
 7.8. Landing Pages
 8. Google Optimiser for Admins
 9. FAQ page functions
 10. Social Media
 11. Enclosed Cart
 11.1. Modal windows
 12. Lens Power descriptions - Basket and Checkout
 13. Map for Collection on Postcode - Basket and Checkout
 14. Auto Re-Order
 15. Postcode Lookup
 16. Browser detection
 17. Show / edit address
 18. Appointment Request (Vettel II)
 19. Legacy funcs to remove
 20. Bastian
 21. GA Measurement Protocol
 22. GrandVision Measurement Protocol
 ----------------------------
*/

/**
 * 1. Global functions
 */
var allow_ajfunction = false;
var original_message = '';
var limited_orginal = '';
var scriptSource = 'desktop';

/**
 * Set allow_ajfunction global variable
 **/
function setAllowRun(a) {
	allow_ajfunction = a;
}

/**
 * Create an object reference using the element Name
 **/
function getObByName(ename) {

	return document.getElementsByName(ename);
}
/**
 * Create an object reference using the element ID
 **/
function getObById(id) {
	/*
	if (document.layers) //Netscape 4
		return eval('document.' + id);
	else if (navigator.userAgent.indexOf("Opera") != -1) //Opera
		return eval("document.all."+id);
	else // all others . . .
	*/
	return document.getElementById(id);
}
/**
 * Create array of object references by className within the document
 **/
function getElementsByClassName(classname) {
	return getSubElementsByClassName(document, classname);
}

// Create array of object references by className within a named parent node.
function getSubElementsByClassName(parentnode, classname) {
	var i;
	var j;
	var rl = new Array();
	var re = new RegExp('(^| )' + classname + '( |$)');
	var ael = parentnode.getElementsByTagName('*');
	var op = (navigator.userAgent.indexOf("Opera") != -1) ? true : false;
	if (parentnode.all && !op) ael = parentnode.all;
	for (i = 0, j = 0; i < ael.length; i++) {
		if (re.test(ael[i].className)) {
			rl[j] = ael[i];
			j++;
		}
	}
	return rl;
}


// return true if the input value is a number
function inputIsNumeric(input_val) {
	return String(input_val).match(/^[\d]+$/) != null;
}

/* Open a new popup window */
function openPopUp(url, windowName, w, h, scrollbar) {
	var winl = (screen.width - w) / 6;
	var wint = (screen.height - h) / 6;
	winprops = 'location=yes,height=' + h + ',width=' + w + ',top=' + wint + ',left=' + winl + ',scrollbars=' + scrollbar + ',resizable=1';
	win = window.open(url, windowName, winprops);
	if (parseInt(navigator.appVersion) >= 4) {
		win.window.focus();
	}
}

/* Set each box height to the height of the box with the highest height
 * If there's only one box, do nothing.
 */
function setMatchingBoxHeights(boxClass, resetHeight) {
	if ($("." + boxClass).length > 1) {
		var maxHeight = -1;
		if (resetHeight == true) {
			$("." + boxClass).css("height", "auto");
		}
		$("." + boxClass).each(function (i) {
			maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
		});
		if (maxHeight > 0) {
			$("." + boxClass).height(maxHeight);
		}
	}
}

/*
	Toggle visibility of class or id passed in
*/
function toggleVisibility(event, element) {
	event.preventDefault();

	var elementToToggle = document.querySelector(element);

	if (elementToToggle) {
		elementToToggle.classList.toggle('is-not-visible');
	};
}

/**
 * 4. AJAX - Create connection to server
 **/
function getXMLHttp() {
	var xmlHttp
	try {
		//Firefox, Opera 8.0+, Safari
		xmlHttp = new XMLHttpRequest();
	}
	catch (e) {
		//Internet Explorer
		try {
			xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
		}
		catch (e) {
			try {
				xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
			}
			catch (e) {
				alert(errorNoAjax)
				return false;
			}
		}
	}
	return xmlHttp;
}

/**
 * 5. Validation
 */

/**
 * Registration - Confirm T&Cs checked
 */
var contreg = false;
function contReg() {
	contreg = true;
	validate();
}

/**
 * Email validator
 **/
function emailCheck(emailStr) {
	if (emailStr == '') {
		return '';
	}
	emailStr = emailStr.replace(/\s/g, "");
	var emailPat = /^(.+)@(.+)$/;
	var specialChars = "\\(\\)<>@,;:\\\\\\\"\\.\\[\\]";
	var validChars = "\[^\\s" + specialChars + "\]";
	var quotedUser = "(\"[^\"]*\")";
	var ipDomainPat = /^\[(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\]$/;
	var atom = validChars + '+';
	var word = "(" + atom + "|" + quotedUser + ")";
	var userPat = new RegExp("^" + word + "(\\." + word + ")*$");
	var domainPat = new RegExp("^" + atom + "(\\." + atom + ")*$");
	var matchArray = emailStr.match(emailPat);
	var errStr = null;
	if (matchArray == null) {
		errStr = errorEmailFormat;
		return errStr;
	}
	var user = matchArray[1]
	var domain = matchArray[2]
	if ((user.match(userPat) == null) && (errStr == null)) {
		errStr = errorEmailUsernameInvalid;
		return errStr;
	}
	var IPArray = domain.match(ipDomainPat);
	if (IPArray != null) {
		for (var i = 1; i <= 4; i++) {
			if ((IPArray[i] > 255) && (errStr == null)) {
				errStr = errorEmailDomainIpInvalid;
				return errStr;
			}
		}
	}
	var domainArray = domain.match(domainPat);
	if ((domainArray == null) && (errStr == null)) {
		errStr = errorEmailDomainInvalid;
		return errStr;
	}
	var atomPat = new RegExp(atom, "g");
	var domArr = domain.match(atomPat);
	var len = domArr.length;
	if ((len < 2) && (errStr == null)) {
		errStr = errorEmailDomainMissing;
		return errStr;
	}
	if ((domArr[domArr.length - 1].length < 2 || domArr[domArr.length - 1].length > 63) && (errStr == null)) {
		errStr = errorEmailDomainEnding + domArr[domArr.length - 1] + errorNotValid;
		return errStr;
	}
	return errStr;
}

/**
 * Helper to convert color codes
 **/
function toHex(rgb) {
	var h = rgb.toString(16);
	if (h.length == 1) { h = '0' + h; }
	if (h.length == 0) { h = '00'; }
	if (h.length > 2) { h = 'ff'; }
	return h;
}

/**
 * Color form elements on error
 * rtarg,gtarg,btarg,rstep,gstep and bstep are sent through in an array, color_arr, which is an optional parameter.
 * If color_arr is not set, then we use the global values, to support old uses of colorError
 **/
function colorError(fld, r, g, b, color_arr) {

	// Set the default holder of color values
	var holder = window;
	// Override it if color_arr is set
	if (typeof (color_arr) != 'undefined') {
		holder = color_arr;
	}
	// assign the value of global color values to local ones.
	var rtarg = holder.rtarg;
	var gtarg = holder.gtarg;
	var btarg = holder.btarg;
	var rstep = holder.rstep;
	var gstep = holder.gstep;
	var bstep = holder.bstep;
	var mode = holder.mode;
	var testmode = holder.testmode;

	var box = getObById(fld);
	if (r > rtarg + rstep || r < rtarg - rstep || g > gtarg + gstep || g < gtarg - gstep || b > btarg + bstep || b < btarg - bstep) {
		if (r < 1) { r = 0; }
		if (g < 1) { g = 0; }
		if (b < 1) { b = 0; }
		var rh = toHex(r);
		var gh = toHex(g);
		var bh = toHex(b);
		var hex = '#' + rh + gh + bh;
		if (mode.indexOf(' border ') != -1) { box.style.borderColor = hex; }
		if (mode.indexOf(' background ') != -1) { box.style.backgroundColor = hex; }
		if (mode.indexOf(' text ') != -1) { box.style.color = htext; }
		if (testmode == true) {
			var errpr = getObById('jsErrors');
			errpr.innerHTML += '<span style="width:1px; height:5px; background-color:' + hex + '; color:' + hex + ';">.</span>';
		}
		if (r > rtarg) { r = r - rstep; }
		if (r < rtarg) { r = r + rstep; }
		if (g > gtarg) { g = g - gstep; }
		if (g < gtarg) { g = g + gstep; }
		if (b > btarg) { b = b - bstep; }
		if (b < btarg) { b = b + bstep; }

		var f = function () { colorError(fld, r, g, b, color_arr); };
		setTimeout(f, 30);

	} else {
		$(box).addClass("colorError");
	}
}

/**
 * Disable and Enable submit button
 */
var tfid = false;
function disableFSubmit(but, ani) {
	var b = getObById(but);
	var a = getObById(ani);
	// b should be undefined for the new desktop skin, so the else does the new disable button work.
	if (a && b) {
		b.disabled = true;
		a.style.display = 'block';
	} else {
		disableAButton(but);
		$("#" + but).addClass("c-button--is-loading");
	}

	tfid = true;
}
function enableSubmit(but, ani) {
	var b = getObById(but);
	var a = getObById(ani);
	if (a && b) {
		b.disabled = false;
		a.style.display = 'none';
	} else {
		enableAButton(but);
		$("#" + but).removeClass("c-button--is-loading");
	}
	tfid = false;
}

function disableAButton(buttonId) {
	$("#" + buttonId).prop('disabled', true);
}
function enableAButton(buttonId) {
	$("#" + buttonId).prop('disabled', false);
}
function iterateThroughButtonsAndDisable(disableButtons) {
	for (i = 0; i < disableButtons.length; i++) {
		disableFSubmit(disableButtons[i].button, disableButtons[i].anim);

	}
}
function iterateThroughButtonsAndEnable(disableButtons) {
	for (i = 0; i < disableButtons.length; i++) {
		enableSubmit(disableButtons[i].button, disableButtons[i].anim);
	}
}
/**
 * General global form validation
 *
 * validation_values is an optional param:
 *
 * a) if empty (old style):
 *   i) we use the javascript validation variables set as global variables within the page, accessed as attributes of "window".
 *  ii) we use the default "jserrors" ID value as the error container
 *
 * b) if not empty (updated):
 *   i) we're passing an object literal whose attributes are matching validation variables.
 *  ii) we set the ID value of the error container (key is "error_container" within the object literal)
 *
 */
function validate(validation_values) {
	// Set the default holder of validation values
	var holder = window;
	// Set the default error container ID
	var error_container_id = "jsErrors";

	// Replace default holder with a custom one, if a valdation_values value is passed.
	if (typeof (validation_values) != 'undefined') {
		holder = validation_values;
	}

	if (typeof (holder.error_container_id) != 'undefined') {
		error_container_id = holder.error_container_id;
	}

	/**
	 * Assign local versions of the variables.
	 * They only last while the function runs, so don't overwrite the originals.
	 */

	var ftv = holder.ftv;
	var same = holder.same;
	var esame = holder.esame;
	var efs = holder.efs;
	var dfs = holder.dfs;
	var ood = holder.ood;
	var nmfs = holder.nmfs;
	var tlfs = holder.tlfs;
	var terms = holder.terms;
	var lsconsentvar = holder.lsconsentvar;
	var termsGAEventVals = holder.termsGAEventVals;
	var mode = holder.mode;
	var htext = holder.htext;
	var r = holder.r;
	var g = holder.g;
	var b = holder.b;
	var rtarg = holder.rtarg;
	var gtarg = holder.gtarg;
	var btarg = holder.btarg;
	var rstep = holder.rstep;
	var gstep = holder.gstep;
	var bstep = holder.bstep;
	var testmode = holder.testmode;
	var disableButton = holder.disableButton;
	var errorUnknownFormField = holder.errorUnknownFormField;
	var errorCompleteRequired = holder.errorCompleteRequired;
	var errorCorrectDateFormat = holder.errorCorrectDateFormat;
	var errorPrescriptionExpired = holder.errorPrescriptionExpired;
	var errorTelephoneNumbers = holder.errorTelephoneNumbers;
	var errorPasswordsNotMatch = holder.errorPasswordsNotMatch;
	var errorEmailsNotMatch = holder.errorEmailsNotMatch;
	var errorOptionRequired = holder.errorOptionRequired;
	var errorConfirmTerms = holder.errorConfirmTerms;
	var errorConfirmConsent = holder.errorConfirmConsent;
	var errorEmailFormat = holder.errorEmailFormat;
	var errorEmailUsernameInvalid = holder.errorEmailUsernameInvalid;
	var errorEmailDomainIpInvalid = holder.errorEmailDomainIpInvalid;
	var errorEmailDomainInvalid = holder.errorEmailDomainInvalid;
	var errorEmailDomainMissing = holder.errorEmailDomainMissing;
	var errorEmailDomainEnding = holder.errorEmailDomainEnding;
	var errorInputNotNumeric = holder.errorInputNotNumeric;
	var errorNotValid = holder.errorNotValid;
	var disableButtons = holder.disableButtons;
	var over16Fields = holder.over16Fields;
	var isAddressForm = holder.isAddressForm;
	var sameErrorGA = holder.sameErrorGA;
	var esameErrorGA = holder.esameErrorGA;
	// Object literal to contain rgb colorError colours
	var color_ob = {
		rtarg: rtarg,
		gtarg: gtarg,
		btarg: btarg,
		rstep: rstep,
		gstep: gstep,
		bstep: bstep,
		mode: mode,
		testmode: testmode
	}
	clearValidateResults(mode, error_container_id);

	// Add any required address fields to the fields to value array.
	if ((typeof (required_address_fields) != 'undefined') && ((typeof (isAddressForm) != 'undefined') && isAddressForm)) {
		ftv = ftv.concat(required_address_fields);
	}
	if (tfid == true) {
		return false;
	}
	if (typeof (disableButton) != 'undefined') {
		disableFSubmit(disableButton[0], disableButton[1]);
	}
	// Regular expression to match a date format
	var re_date = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

	// Regular expression to match a telephone format
	var re_tel = /^[\d\.\s\-\+]+$/;

	var es = ''; //Error String/
	var en = 0; //Error number/
	var elist = ''; //List of fields-to-value which have an associated error.

	var vlen = ftv.length; // count the fields to validate
	var efsarr = efs.split(" ");
	var efslen = efsarr.length; // count the email fields to check
	var tfsarr = tlfs.split(" ");
	var tfslen = tfsarr.length; // count the telephone fields to check
	if (typeof (nmfs) != "undefined") {
		var nmfsarr = nmfs.split(" ");
		var nmfslen = nmfsarr.length; // count the telephone fields to check
	}

	//Prime the form fields/
	for (i = 0; i < vlen; i++) {
		if (!getObById(ftv[i])) {
			if (testmode == true) {
				alert(errorUnknownFormField + " - '" + ftv[i] + "'");
				return false;
			}
		} else {
			var rd = toHex(r);
			var gd = toHex(g);
			var bd = toHex(b);
			getObById(ftv[i]).style.borderColor = '#' + rd + gd + bd;
		}
	}
	for (i = 0; i < vlen; i++) {
		if (getObById(ftv[i])) {

			var fob = getObById(ftv[i]);

			if ((fob.type == 'text') || (fob.type == 'textarea') || (fob.type == 'password') || (fob.type == 'email') || (fob.type == 'tel') || (fob.type == 'number')) {
				//Do empty fields first
				var strvalue = fob.value.replace(/(^\s+)|(\s+$)/g, '');
				if (strvalue == '') {
					colorError(ftv[i], r, g, b, color_ob);
					elist += ftv[i];
					if (es.indexOf(errorCompleteRequired) == -1) {
						en += 1;
						es += en + '. ' + errorCompleteRequired + '<br />';
					}
				} else {
					//Check email formats
					if (efs.indexOf(' ' + ftv[i] + ' ') != -1) {
						var emailStr = fob.value;
						var emailErr = emailCheck(emailStr);
						if (emailErr != null) {
							colorError(ftv[i], r, g, b, color_ob);
							elist += ftv[i];
							if (es.indexOf(emailErr) == -1) {
								en += 1;
								es += en + '. ' + emailErr + '<br />';
							}
						}
					}
					//Check date formats
					if (dfs.indexOf(' ' + ftv[i] + ' ') != -1) { // if the dfs list contains the id of the current field to validate we're looking at
						if (!fob.value.match(re_date)) { // If the value of the current input doesn't match the regular expression for dates
							colorError(ftv[i], r, g, b, color_ob);
							elist += ftv[i];
							en += 1;
							es += en + '. ' + errorCorrectDateFormat + '<br />';
						} else { // i.e. the value of the current input _does_ match the regular expression for dates
							//Check date entered is not 'out of date'
							if ((ood.indexOf(' ' + ftv[i] + ' ') != -1) && (contreg == false)) { // if the ood list contains the id of the current field we're looking at, and customer hasn't chosen to continue anyway
								var today = new Date(); //construct a date object set to right now
								var endDate = new Date(); //construct a date object set to right now
								var ed = fob.value; // ed set to the value of the current input
								var darr = ed.split('/'); // create an array from the dateval, split on /
								var endDay = darr[0]; // giving you end-day
								var endMonth = darr[1] - 1; // giving you end-month (months index from 0)
								var endYear = darr[2];  // giving you end-year
								endDate.setFullYear(endYear, endMonth, endDay); // set endDate to the date in the input
								if (endDate < today) {
									colorError(ftv[i], r, g, b, color_ob);
									elist += ftv[i];
									en += 1;
									es += en + '. ' + errorPrescriptionExpired + '<br />';
								}
							}
						}
					}
					if (dfs.indexOf(' ' + ftv[i] + ' ') != -1) { // if the dfs list contains the id of the current field to validate we're looking at
						if (!fob.value.match(re_date)) { // If the value of the current input doesn't match the regular expression for dates
							colorError(ftv[i], r, g, b, color_ob);
							elist += ftv[i];
							en += 1;
							es += en + '. ' + errorCorrectDateFormat + '<br />';
						} else { // i.e. the value of the current input _does_ match the regular expression for dates
							//Check date entered is not 'out of date'
							if ((ood.indexOf(' ' + ftv[i] + ' ') != -1) && (contreg == false)) { // if the ood list contains the id of the current field we're looking at, and customer hasn't chosen to continue anyway
								var today = new Date(); //initialise a date to right now
								var endDate = new Date(); //initialise a date to right now
								var ed = fob.value; // ed set to the value of the current input
								var darr = ed.split('/'); // create an array from the dateval, split on /
								var endDay = darr[0]; // giving you end-day
								var endMonth = darr[1] - 1; // giving you end-month (months index from 0)
								var endYear = darr[2];  // giving you end-year
								endDate.setFullYear(endYear, endMonth, endDay); // set endDate to the date in the input
								if (endDate < today) {
									colorError(ftv[i], r, g, b, color_ob);
									elist += ftv[i];
									en += 1;
									es += en + '. ' + errorPrescriptionExpired + '<br />';
								}
							}
						}
					}
					//Check telephone formats
					if (tlfs.indexOf(' ' + ftv[i] + ' ') != -1) {
						var tlfld = fob;
						if (!tlfld.value.match(re_tel)) {
							colorError(ftv[i], r, g, b, color_ob);
							elist += ftv[i];
							en += 1;
							es += en + '. ' + errorTelephoneNumbers + '<br />';
						}
					}

					// Check whether an input is numeric and > 0
					if (typeof (nmfs) != "undefined" && (nmfs.indexOf(' ' + ftv[i] + ' ') != -1)) {
						var nmfld = fob;
						if (!inputIsNumeric(nmfld.value) || (nmfld.value < 1)) {
							colorError(ftv[i], r, g, b, color_ob);
							elist += ftv[i];
							en += 1;
							es += en + '. ' + errorInputNotNumeric + '<br />';
						}
					}

					//Check passwords match
					if ((same.length == 2) && ((ftv[i] == same[0]) || (ftv[i] == same[1]))) {
						if ((getObById(same[0]).value != getObById(same[1]).value) && (getObById(same[0]).value != '') && (getObById(same[1]).value != '')) {
							colorError(ftv[i], r, g, b, color_ob);
							elist += ftv[i];
							if ((ftv[i] == same[1])) {
								if (typeof (sameErrorGA) != "undefined") {
									GA_Event_Trigger(sameErrorGA['cat'], sameErrorGA['act'], sameErrorGA['lab']);
								}
								en += 1;
								es += en + '. ' + errorPasswordsNotMatch + '<br />';
							}
						}
					}
					//Check emails match
					if (typeof (esame) != 'undefined') {
						if ((esame.length == 2) && ((ftv[i] == esame[0]) || (ftv[i] == esame[1]))) {
							if ((getObById(esame[0]).value != getObById(esame[1]).value) && (getObById(esame[0]).value != '') && (getObById(esame[1]).value != '')) {
								colorError(ftv[i], r, g, b, color_ob);
								elist += ftv[i];
								if ((ftv[i] == esame[1])) {
									if (typeof (esameErrorGA) != "undefined") {
										GA_Event_Trigger(esameErrorGA['cat'], esameErrorGA['act'], esameErrorGA['lab']);
									}
									en += 1;
									es += en + '. ' + errorEmailsNotMatch + '<br />';
								}
							}
						}
					}
				}
			}
			if (fob.type == 'select-one') {
				var sindx = fob.selectedIndex;
				var sopval = fob.options[sindx].value;
				if ((sopval == "--") || (sopval == "") || (sopval == null) || (sopval.indexOf("Please Select") != -1)) {
					var oldmode = mode;
					var oldrtarg = rtarg;
					var oldgtarg = gtarg;
					var oldbtarg = btarg;
					var oldrstep = rstep;
					var oldgstep = gstep;
					var oldbstep = bstep;
					mode = ' background '; //Force the highlight mode to include background for IE /
					rtarg = 245;
					gtarg = 245;
					btarg = 245;
					rstep = 3;
					gstep = 2;
					bstep = 2;
					colorError(ftv[i], r, g, b, color_ob);
					elist += ftv[i];
					mode = oldmode;
					rtarg = oldrtarg
					gtarg = oldgtarg;
					btarg = oldbtarg;
					rstep = oldrstep;
					gstep = oldgstep;
					bstep = oldbstep;
					if ((es.indexOf(errorOptionRequired) == -1) && (es.indexOf(errorCompleteRequired) == -1)) {
						en += 1;
						es += en + '. ' + errorOptionRequired + '<br />';
					}
				}


				//Check prescription is not expired
				if (typeof (prescriptionExpired) != "undefined" && (prescriptionExpired.indexOf(' ' + ftv[i] + ' ') != -1)) {
					if (typeof ($(fob).find(":selected").data("prescriptionexpired")) != "undefined" && $(fob).find(":selected").data("prescriptionexpired")) {
						colorError(ftv[i], r, g, b, color_ob);
						elist += ftv[i];
						en += 1;
						es += en + '. ' + errorPrescriptionExpired + '<br />';
					}
				}


			}
			if (fob.type == 'radio') {
				var radnm = fob.name;
				var radgp = document.getElementsByName(radnm);
				var radlen = radgp.length;
				var chk = 0;
				for (j = 0; j < radlen; j++) {
					if (radgp[j].checked == true) {
						chk = 1;
					}
				}
				if (chk == 0) {
					colorError(ftv[i], r, g, b, color_ob);
					elist += ftv[i];
					if ((es.indexOf(errorOptionRequired) == -1) && (es.indexOf(errorCompleteRequired) == -1)) {
						en += 1;
						es += en + '. ' + errorOptionRequired + '<br />';
					}
				}
			}
			if (fob.type == 'checkbox') {
				//need to write this/

				//Check terms are agreed to
				if (terms && (terms.indexOf(ftv[i]) != -1)) {
					if (fob.checked != true) {
						colorError(ftv[i], r, g, b, color_ob);
						elist += ftv[i];
						if (es.indexOf(errorCompleteRequired) == -1) {
							en += 1;
							es += en + '. ' + errorConfirmTerms + '<br />';
						}
						if (typeof (termsGAEventVals) != 'undefined') {
							GA_Event_Trigger(termsGAEventVals['category'], termsGAEventVals['action'], termsGAEventVals['label'])
						}
					}
				}

				if (lsconsentvar && (lsconsentvar.indexOf(ftv[i]) != -1)) {
					if (fob.checked != true) {
						colorError(ftv[i], r, g, b);
						elist += ftv[i];
						if (es.indexOf(errorCompleteRequired) === -1) {
							en += 1;
							es += en + '. ' + errorConfirmConsent + '<br />';
						}
					}
				}
			}
		}
	}
	for (var k = 0; k < efslen; k++) {
		if (efsarr[k].length > 0) {
			var ftvstr = ftv.toString();
			if (ftvstr.indexOf(efsarr[k]) == -1) {
				var fob = getObById(efsarr[k]);
				var emailStr = fob.value;
				if (emailStr != '') {
					var emailErr = emailCheck(emailStr);
					if ((emailErr != '') && (emailErr != null)) {
						colorError(efsarr[k], r, g, b, color_ob);
						elist += ftv[i];
						if (es.indexOf(emailErr) == -1) {
							en += 1;
							es += en + '. ' + emailErr + '<br />';
						}
					}
				}
			}
		}
	}

	for (var t = 0; t < tfslen; t++) {
		if (tfsarr[t].length > 0) {
			var ftvstr = ftv.toString();
			if (ftvstr.indexOf(tfsarr[t]) == -1) {
				var fob = getObById(tfsarr[t]);
				if (!fob.value.match(re_tel) && fob.value != '') {
					colorError(tfsarr[t], r, g, b, color_ob);
					elist += ftv[i];
					if (es.indexOf(errorTelephoneNumbers) == -1) {
						en += 1;
						es += en + '. ' + errorTelephoneNumbers + '<br />';
					}
				}
			}
		}
	}

	// Check 3-box date.
	// If any of the over 16 date fields have an error (i.e. haven't been selected), there's no point further here.

	if (typeof (over16Fields) != 'undefined' && over16Fields) {
		var over16FieldHasError = false;
		for (var key in over16Fields) {
			if (elist.indexOf(over16Fields[key]) > 0) {
				over16FieldHasError = true;
			}
			if (over16FieldHasError) {
				break;
			}
		}
		if (!over16FieldHasError) {
			var dayob = getObById(over16Fields["day"]);
			var dayindx = dayob.selectedIndex;
			var dayval = dayob.options[dayindx].value;
			var monob = getObById(over16Fields["month"]);
			var monindx = monob.selectedIndex;
			var monval = monob.options[monindx].value;
			var yearob = getObById(over16Fields["year"]);
			var yearindx = yearob.selectedIndex;
			var yearval = yearob.options[yearindx].value;
			var dateOfBirth = new Date(yearval, monval - 1, dayval);
			if (!moreThanNYearsAgo(16, dateOfBirth)) {
				colorError(over16Fields["day"], r, g, b, color_ob);
				colorError(over16Fields["month"], r, g, b, color_ob);
				colorError(over16Fields["year"], r, g, b, color_ob);
				elist += over16Fields["day"] + over16Fields["month"] + over16Fields["year"];
				if (es.indexOf(errorUnder16) == -1) {
					en += 1;
					es += en + '. ' + errorUnder16 + '<br />';
				}

			}
		}
	}


	var errp = getObById(error_container_id);

	if (es != '') {
		if (typeof (holder.containerIsParagraph !== "undefined") && holder.containerIsParagraph) {
			var paragraphContainer = $("<p />");
			es = paragraphContainer.append(es);
		}
		$(errp).html(es);
		if (typeof (disableButton) != 'undefined') {
			enableSubmit(disableButton[0], disableButton[1]);
		}
		if (disableButtons) {
			iterateThroughButtonsAndEnable(disableButtons);
		}
		$(errp).show();
		if (typeof noscrolltoerror == 'undefined') {
			$('html, body').animate({
				scrollTop: $(errp).offset().top
			}, 1000);
		}
		return false;
	} else {
		if (typeof (deferr) != 'undefined') {
			errp.innerHTML = deferr;
			$(errp).show();
			$('html, body').animate({
				scrollTop: $(errp).offset().top
			}, 1000);
		} else {
			errp.innerHTML = '';
			$(errp).hide();
		}
		return true;
	}
}
function sendAppointmentConsent(form) {
	updateAppointmentRequest($("input#consent"), form);
	return false;
}
// Clear any styles that are added by validate. Empty the error container and hide it.
function clearValidateResults(mode, containerId) {
	if (mode.indexOf("background") > -1) {
		$(".colorError").css("background", "").removeClass("colorError");
	}
	if (mode.indexOf("border") > -1) {
		$(".colorError").css("border-color", "").removeClass("colorError");
	}
	$("#" + containerId).html("").hide();
}

function checkFilled(elid) {
	var filled = $('#' + elid).val();
	if (filled == '') {
		return false;
	} else {
		return true;
	}
}

// Pass n years and a date object. Returns true / false to whether that date is more than n years ago from today
function moreThanNYearsAgo(years, userDate) {
	var today = new Date();
	var nYearsAgo = new Date(today.setFullYear(today.getFullYear() - years));
	nYearsAgo.setHours(0, 0, 0, 0);
	userDate.setHours(0, 0, 0, 0);
	return userDate <= nYearsAgo;
}



/**
 * 7. Specific Pages
 */

/**
 * 7.2. Product search
 * Enter an optional param to specify a specific search input's ID, otherwise use the default "searchBox" which is the id of the perm-nav searchbox.
 **/
function doSearch(searchBoxId) {
	var searchId = (typeof searchBoxId === "undefined") ? "searchBox" : searchBoxId;

	if (getObById(searchId) != null) {
		var srch = getObById(searchId);
		srch = srch.value;
		if (srch != '') {
			MarketingEvents.trigger('Search', srch, 'search');

			GA_Event_Trigger('Search', 'click', srch);

			var searchdomain;
			var reg_replace = /[^[:alnum:]¡¿ÄäÀàÁáÂâÃãÅåǍǎĄąĂăÆæĀāÇçĆćĈĉČčĎđĐďðÈèÉéÊêËëĚěĘęĖėĒēĜĝĢģĞğĤĥÌìÍíÎîÏïıĪīĮįĴĵĶķĹĺĻļŁłĽľÑñŃńŇňŅņÖöÒòÓóÔôÕõŐőØøŒœŔŕŘřẞßŚśŜŝŞşŠšȘșŤťŢţÞþȚțÜüÙùÚúÛûŰűŨũŲųŮůŪūŴŵÝýŸÿŶŷŹźŽžŻż\s]/g;
			srch = srch.replace(reg_replace, '');
			srch = srch.replace(' ', '+');
			srch = srch.toLowerCase();
			if (document.domain + "" == 'localhost') {
				return true;
			} else if ('undefined' !== typeof (rootURL)) {
				searchdomain = rootURL;
			} else {
				pc = document.location.protocol + '//';
				dm = document.domain + '';
				searchdomain = pc + dm + '/';
			}
			srch = searchBaseUrl + "/" + srch;
			document.location = searchdomain + srch;
		}
	}

	return false;
}

/**
 * 7.3. Product Page
 */
/**
 * Show / hide second eye
 **/
function toggleRightEye() {
	var yops = getObById('Options1');
	var xops = getObById('Options2');
	var opst = getObById('optntitle');
	var unitval = $('input[name=units]:checked', '#addtobasket').val();
	if (unitval == 2) {
		$("#Options2, #Options2Label").show();
		$(".opts-description").hide();
		$("#Options1").removeClass("only-options");
		opst.innerHTML = leftEye;
	} else {
		$("#Options2, #Options2Label").hide();
		$(".opts-description").show();
		$("#Options1").addClass("only-options");
		opst.innerHTML = oneEye;
	}
}


/**
 * Read another testimonial
 **/
function readAnother(siteroot, partner) {
	Animate('start');
	var xmlHttp = getXMLHttp();
	xmlHttp.onreadystatechange = function () {
		if (xmlHttp.readyState == 4) {
			HandleResponse(xmlHttp.responseText);
		}
	}
	xmlHttp.open("GET", siteroot + "/?_g=rm&type=rt&ps=" + partner + "&rand=" + Math.random(), true);
	xmlHttp.send(null);
}

/**
 * Customer has seen prescription warning
 **/
function rememberPrescriptionWarning(warntype) {
	if (warntype == 1 || warntype == 'p') {
		warntype = 'p';
	} else if (warntype == 2 || warntype == 'bc') {
		warntype = 'bc';
	} else {
		warntype = false;
	}
	if (warntype != false) {
		var xmlHttp = getXMLHttp();
		xmlHttp.open("GET", rootURL + "?_g=ex&type=rpw&wt=" + warntype + "&rand=" + Math.random(), true);
		xmlHttp.send(null);
	}
}

function displayLiveStockLevel(whicheye, stockmessage) {
	$("#live_stock_level_" + whicheye).html(stockmessage);
}

function fetchLiveStockLevel(siteroot, whicheye, skukey) {
	var xmlHttp = getXMLHttp();
	var allFieldsSelected = true;
	var $productOption = $('select[name="productOptions[]"]');
	var productOptionOnePassed = true;
	var $productOptionTwo = $('select[name="productOptions2[]"]');
	var productOptionTwoPassed = true;

	if ($productOption.parents('.product-options-box').css('display') !== "none") {
		$('select[name="productOptions[]"] option:selected').each(function() {
			if ($(this).text() === "--") {
				productOptionOnePassed = false;
			}
		});
	}

	if ($productOptionTwo.parents('.product-options-box').css('display') !== "none") {
		$('select[name="productOptions2[]"] option:selected').each(function () {
			if ($(this).text() === "--") {
				productOptionTwoPassed = false;
			}
		});
	}

	if (productOptionOnePassed === false || productOptionTwoPassed === false) {
		allFieldsSelected = false;
	}
	xmlHttp.onreadystatechange = function () {
		if (xmlHttp.readyState == 4) {
			var docResponse = JSON.parse(xmlHttp.responseText);
			displayLiveStockLevel(whicheye, docResponse['stock_level_text']);
			if (docResponse['stock_level_explanation']) {
				var $stockElement = $("#live_stock_level_" + whicheye);
				$stockElement.addClass('skuStockLevelHoverable u-hoverable');
				$stockElement.attr('data-tooltip', docResponse['stock_level_explanation']);
				$stockElement.trigger('tooltip.show');
			} else {
				$(document).trigger('tooltip.clear.stock', $("#live_stock_level_" + whicheye));
			}
			if (typeof docResponse.show_alt_prod_popup !== 'undefined' && docResponse.show_alt_prod_popup === true) {
				DispatchHandler.alternativeProductShow({
					redirect: docResponse.alt_prod_popup_url || ''
				});
			}
		}
	}
	xmlHttp.open("GET", siteroot + "/?_g=ex&action=livestocklevel&skukey=" + skukey + "&rand=" + Math.random() + '&allselected='+allFieldsSelected, true);
	xmlHttp.send(null);
}

function checkLiveStockLevel(siteroot, whicheye) {
	if (whicheye == 1) {
		var whicheyelabel = '';
	} else {
		var whicheyelabel = '2';
	}

	var productOptions = getObByName('productOptions' + whicheyelabel + '[]');
	var productId = getObByName('add');

	if (!productOptions.length || !productId.length) {
		return false;
	}

	var arrayoptionsvalues = buildProductOption(productOptions, productId[0].value);
	if (arrayoptionsvalues.indexOf("--") < 0 && quickValidSKU(whicheye) == true) {
		fetchLiveStockLevel(siteroot, whicheye, arrayoptionsvalues);
	} else {
		removeTooltip("live_stock_level_" + whicheye);
		$("#live_stock_level_" + whicheye).html('');
	}
}

function setSkuDelayWarningContent(skuContent) {
	$("#skuDelaysWarningContent").html(skuContent);
}

function emptySkuDelayWarningContent() {
	$("#skuDelaysWarningContent").html("");
}

function showSkuDelayWarning() {
	$("#skuDelaysWarning").show();
}

function hideSkuDelayWarning() {
	$("#skuDelaysWarning").hide();
}

function removeTooltip(elementId) {
	var el = $("#" + elementId);
	el.removeClass("skuStockLevelHoverable u-hoverable");
	el.off("mouseenter.tooltip mouseleave.tooltip");
}

/**
 * Ajax function to get delivery estimation
 * Build a list of  valid details required to call the ajax function
 * This will result in displaying the date or extra information within the dispatch information box
 **/
function getDispatchDelivery(siteroot) {
	if (allow_ajfunction && getObByName('add').length > 0) {
		if (window.getProduct && typeof window.getProduct === 'function') {
			var product = getProduct();
			window.isPrescriptionAbandom = true;

			var productId = product.getProductId();
			var sendParameters = '';
			var strAccessoriesIds = '';
			var strOptionsIds = '';
			var strSecondaryOptionsIds = '';
			var units = product.getUnits();
			var quantity = product.getQuantity();
			var dispatchDeliveryElement = $('#dispatch_delivery');
			var originalMessage = window.original_message ||
				dispatchDeliveryElement ? dispatchDeliveryElement.html() : '';

			if(product.getProductHasOptions()) {
				strOptionsIds = Array.from(product.getProductOptions()['first_unit']).map(function(option){
					return option.value;
				}).join('|');
				sendParameters = sendParameters + '&arrayoptionsvalues=' + productId + ':' + strOptionsIds;

				if(units > 1 && product.getProductOptionsValid('second_unit')) {
					strSecondaryOptionsIds = Array.from(product.getProductOptions()['second_unit']).map(function(option){
						return option.value;
					}).join('|');
					sendParameters = sendParameters + '&arrayoptionsvalues2=' + productId + ':' + strSecondaryOptionsIds;
				}
			} else {
				sendParameters += '&arrayoptionsvalues=' + productId + ':';
			}

			if(product.getHasAccessories()) {
				strAccessoriesIds = Array.from(product.getSelectedAccessories()).map(function(value) {
					return value + ':';
				}).join();

				sendParameters = '&accessories=' + strAccessoriesIds + sendParameters;
			}

			if(sendParameters.indexOf('--') === -1 && quantity > 0) {
				var isValid = validateOptions('livestock');

				if(units > 0 && isValid || units === 0) {
					$('#jsErrors').css({display:'none'});

					if(strOptionsIds === strSecondaryOptionsIds) {
						quantity = quantity * 2;
					}

					if (typeof prodHasOptions !== 'undefined' && prodHasOptions) {
						GA_Event_Trigger('prescriptionInputted', 'yes', '');

						window.isPrescriptionAbandom = false;
						window.isBasketAbandom = true;

						if (typeof window.hj !== 'undefined') {
							hj('tagRecording', ['prescription-completion']);
						}
					}

					sendParameters = sendParameters + '&qty=' + quantity;
					AnimateIcon('start');
					$("#dispatchInfoBlock").hide();
					$("#dispatchLoadingBlock").show();

					var xmlHttp = getXMLHttp();
					xmlHttp.onreadystatechange = function () {
						if (xmlHttp.readyState == 4) {
							HandleDatesResponse(xmlHttp.responseText);

							var response = JSON.parse(xmlHttp.responseText);

							if(response['limited_stock_issue']) {
								var debugData = {};
								debugData['product'] = product.export();
								debugData['request_data'] = {
									"0_send_parameters": sendParameters,
									"1_product_id": productId,
									"2_str_options_ids": strOptionsIds,
									"3_str_secondary_options_ids": strSecondaryOptionsIds,
									"4_str_accessories_ids": strAccessoriesIds,
									"5_validation_result": isValid,
									"6_quantity": quantity
								};
								debugData['url'] = {
									"site_root": siteroot,
									"uri": document.location.pathname,
									"query": document.location.search
								};

								var debugPost = {};
								debugPost['msg'] = 'Limited stock debug data';
								debugPost['data'] = debugData;

								var xmlHttpDebug = getXMLHttp();
								xmlHttpDebug.open("POST", siteroot + '/?_g=ex&type=limitedStockDebug', true);
								xmlHttpDebug.setRequestHeader('Content-type', 'application/json');
								xmlHttpDebug.send(JSON.stringify(debugPost));
							}
						}
					}
					qty = getObById('quan').value;

					xmlHttp.open("GET", siteroot + "/?_g=ex&type=dd" + sendParameters, true);
					xmlHttp.send(null);
				}
			} else {
				if (originalMessage !== '') {
					$("#dispatch_delivery").html(originalMessage);
				}
			}
		} else {
			getDispatchDeliveryOld(siteroot);
		}
	}

	function getDispatchDeliveryOld() {
		var productId = getObByName('add')[0].value;
		window.isPrescriptionAbandom = true;

		//Always display the original message it's never empty
		if (original_message == '') {
			original_message = $("#dispatch_delivery").html();
		}
		//sendparameters will be filled with products details and quantity selected
		var sendparameters = '';
		var units = $('input[name=units]:checked', '#addtobasket').val();
		var array2valid = false;
		if (getObById('quan')) {
			var qty = getObById('quan').value;
		}
		//Add the options of the product if they have been selected or add just the product id if it's an accessory
		if (getObByName('accessories[]')) {
			var foundaccessories = buildAccessories(getObByName('accessories[]'));
		}
		//Add the options of the product if they have been selected or add just the product id if it's an accessory
		if (getObByName('productOptions[]')) {
			var arrayoptionsvalues = buildProductOption(getObByName('productOptions[]'), productId);
			sendparameters = sendparameters + "&arrayoptionsvalues=" + arrayoptionsvalues;
			if (units && units > 1) {
				var arrayoptionsvalues2 = buildProductOption(getObByName('productOptions2[]'), productId);
				if (arrayoptionsvalues2.indexOf("--") < 0) {
					array2valid = true;
				}
				sendparameters = sendparameters + "&arrayoptionsvalues2=" + arrayoptionsvalues2;
			} else {
				array2valid = true;
			}
		} else {
			var arrayoptionsvalues = productId + ":";
			array2valid = true;
			sendparameters = sendparameters + "&arrayoptionsvalues=" + arrayoptionsvalues;
		}
		//Adds extra accessories ticked on the product page
		if (foundaccessories.length > 0) {
			sendparameters = "&accessories=" + foundaccessories + sendparameters;
		}
		if ((arrayoptionsvalues.indexOf("--") < 0) && (array2valid) && (qty > 0)) {
			//If a product page does not have options to be validated (accessories) make it the function valid
			if (units) {
				checkValidation = validateOptions('livestock');
			} else {
				checkValidation = true;
			}
			if (checkValidation) {
				getObById('jsErrors').style.display = 'none';
				if (arrayoptionsvalues2 == arrayoptionsvalues) {
					qty = qty * 2;
				}
				// David - GA event tracking when prescription is entered.
				if (typeof prodHasOptions !== 'undefined' && prodHasOptions) {
					GA_Event_Trigger('prescriptionInputted', 'yes', '');
					splitEventTrigger('user','prescriptionEntry', 1);

					window.isPrescriptionAbandom = false;
					window.isBasketAbandom = true;

					if (typeof window.hj !== 'undefined') {
						hj('tagRecording', ['prescription-completion']);
					}
				}

				sendparameters = sendparameters + "&qty=" + qty;
				AnimateIcon('start');

				// For rebuilt desktop
				$("#dispatchInfoBlock").hide();
				$("#dispatchLoadingBlock").show();

				//For limited stock product, fill dropdown with available stock only
				/* if(getObById('limitedinfo')) {
					sendparameters = sendparameters+ "&lim=1";
				} */
				//Ajax response displays related distpatch dates info
				var xmlHttp = getXMLHttp();
				xmlHttp.onreadystatechange = function () {
					if (xmlHttp.readyState == 4) {
						HandleDatesResponse(xmlHttp.responseText);
					}
				}
				qty = getObById('quan').value;
				if (arrayoptionsvalues2 == arrayoptionsvalues) {
					qty = qty * 2;
				}
				xmlHttp.open("GET", siteroot + "/?_g=ex&type=dd" + sendparameters, true);
				xmlHttp.send(null);
			} else {
				//if sku not valid, original message for dispatch info is displayed
				if (original_message != '') {
					$("#dispatch_delivery").html(original_message);
				}
			}
		} else {
			//if quantity of sku is available, original message for dispatch info is displayed
			if (original_message != '') {
				$("#dispatch_delivery").html(original_message);
			}
		}
	}

	/**
	 * Show spinner during delivery estimation
	 **/
	function buildAccessories(arrayaccessories) {
		var foundaccessories = [];
		for (var i = 0; i < arrayaccessories.length; i++) {
			if (arrayaccessories[i].checked) {
				foundaccessories.push(arrayaccessories[i].value + ":");
			}
		}
		return foundaccessories;
	}
}

function buildProductOption(arrayoptions, id) {
	var arrayoptionsvalues = [];
	for (var i = 0; i < arrayoptions.length; i++) {
		optionSelect = arrayoptions[i];
		var selIndex = optionSelect.selectedIndex;
		arrayoptionsvalues.push(optionSelect.options[selIndex].value);
	}
	arrayoptionsvalues = id + ":" + arrayoptionsvalues.join("|");
	return arrayoptionsvalues;
}
/**
 * Fill div#testimonial with new testimonial content
 **/
function Animate(op) {
	ob = getObById('loading');
	if (ob) {
		if (op == 'start') {
			ob.style.visibility = 'visible';
		} else {
			ob.style.visibility = 'hidden';
		}
	}
}
/**
 * Show spinner during delivery estimation
 **/
function AnimateIcon(op) {
	if (op == 'start') {
		$("#guesstimationInfo").hide();
		$("#iconloadingDates").show();
	} else {
		$("#iconloadingDates").hide();
		$("#guesstimationInfo").show();
	}
}
/**
 * Fill div#testimonial with new testimonial content
 **/
function HandleResponse(response) {
	getObById('testimonial').innerHTML = response;
	Animate('stop');
}

/**
 * Fill dispatch & delivery info and display stock issue info if applicable and stock is low
 **/
function HandleDatesResponse(response) {
	response = JSON.parse(response);
	//If product has limited stock, response has the minimum quantity available at the begining of the string
	var n = response['minimum_available_qty'];
	//If limited stock, response sends the stock available within the response
	if (n !== "") {
		if (limited_orginal == "") {
			limited_orginal = $("#limitedinfo").html();
		}
		HandleLimitedResponse(n);
		//if there is no stock and item is limited, show error message and disable the add to basket button
		if (n > 0) {
			$("#dispatch_delivery").html(response['estimated_dispatch_day']);
		} else {
			$("#dispatch_delivery").html(original_message);
		}
	} else {
		$("#dispatch_delivery").html(response['estimated_dispatch_day']);
		resetQtyDefaultOptions(original_qty_array);
	}
	if (typeof (response['sku_override_message']) != "undefined" && response['sku_override_message'].length) {
		setSkuDelayWarningContent(response['sku_override_message']);
		GA_Event_Trigger("sku_delay_message", "impression", "product_page");
		showSkuDelayWarning();
	} else {
		emptySkuDelayWarningContent();
		hideSkuDelayWarning();
	}
	// Track the number of days
	GA_Event_Trigger("Product", "Delivery Estimate", response['days_from_today'] + " days from today");
	AnimateIcon('stop');
	// For rebuilt desktop
	$("#dispatchInfoBlock").show();
	$("#dispatchLoadingBlock").hide();
}

/**
 * Fill dropdown content on product page if limited with live available quantity
 */
function HandleLimitedResponse(maxvalue) {
	var thissel = $("#quan option:selected").text();
	$("#quan").empty();
	if (maxvalue > 0) {
		$("#quan").val(1);
		if (maxvalue > limitedqtycap) {
			maxvalue = limitedqtycap;
		}
		$("#quan").hide(); // force redraw of select box in IE.
		for (var i = 1; i <= maxvalue; i++) {
			$("#quan").append($("<option></option>").attr("value", i).text(i));
			if (i == thissel) {
				$("#quan").val(i);
			}
		}
		$("#quan").show(); // force redraw of select box in IE.
		$("#addtobasket_button").prop("disabled", false).removeClass("disabledAddButton");
		$("#limitedinfo").html(limited_orginal);
	} else {
		$("#quan").append($("<option></option>").attr("value", 1).text("--"));
		var message = nomorestock;
		var $messageElement = $("#jsErrors");
		if ($messageElement.hasClass("js-wrap-in-paragraph")) {
			var paragraphContainer = $("<p />");
			message = paragraphContainer.append(message);
		}
		$messageElement.html(message);
		$messageElement.show();

		// Set a class, too, for styling on old IEs.
		$("#addtobasket_button").prop("disabled", true).addClass("disabledAddButton");
	}
}
/**
 * Limited Stock at SKU Level - Reset dropdown to original quantity list
 */
function resetQtyDefaultOptions(original_qty_array) {
	if ($("#quan").is("select")) {
		if (typeof original_qty_array === 'undefined') {
			var original_qty_array = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12);
		}
		var thissel = $("#quan option:selected").text();
		$("#quan").empty();
		$("#quan").hide(); // force redraw of select box in IE.
		for (var i = 0; i < original_qty_array.length; i++) {
			$("#quan").append($("<option></option>").attr("value", original_qty_array[i]).text(original_qty_array[i]));
			if (original_qty_array[i] == thissel) {
				$("#quan").val(original_qty_array[i]);
			}
		}
		$("#quan").show(); // force redraw of select box in IE.
		$("#addtobasket_button").prop("disabled", false).removeClass("disabledAddButton");
	}
}

/**
 * Expand testimonial
 **/
function showText() {
	getObById('fullTestimonialBox').style.display = 'inline';
	getObById('showText').innerHTML = "<a href=\"javascript:hideText();\">[-]</a>";
}
function hideText() {
	getObById('fullTestimonialBox').style.display = 'none';
	getObById('showText').innerHTML = "<a href=\"javascript:showText();\">[+]</a>";
}


/**
 * Basket summary - Display empty basket text
 **/
function emptyCart() {
	var cartbox = getObById('BasketSummary');
	cartbox.innerHTML = emptyCartText;
}

/**
 * Registration - Show information panels
 **/
function showWhy(textbloc, trigger) {
	var marker = getObById(trigger);
	var bloc = getObById(textbloc);
	var posX = marker.offsetLeft;
	var posY = marker.offsetTop;
	bloc.style.display = 'block';

}


/* Reuse the information panel functionality to display the co.uk / .eu options pages */
function showWhyEu(textbloc, trigger) {
	var marker = getObById(trigger);
	var bloc = getObById(textbloc);
	bloc.style.display = 'block';
	var posX = marker.offsetLeft - bloc.offsetWidth;
	var posY = marker.offsetTop;
	bloc.style.left = (posX - 25) + 'px';
}
function hideWhy(textbloc) {
	var bloc = getObById(textbloc);
	bloc.style.display = 'none';
}

/**
 * Registration - Date synchronisation
 **/
function syncDates() {
	var startdate = getObById('prescription_start');
	var enddate = getObById('prescription_end');
	enddate.selectedIndex = startdate.selectedIndex;
}

/**
 * Site Docs / Forms - Get currently selected form elements (Estelle)
 **/
function setSelection(element_name, option_value) {
	if (option_value == '')
		return;
	elems = document.getElementsByName(element_name);
	for (var i = 0; elems && i < elems.length; i++) {
		el = elems[i];
		if (el && !el.length && el.value == option_value) {
			el.checked = true;
		} else if (el) {
			for (var j = 0; j < el.length; j++) {
				if (el[j].value == option_value) {
					if (el.options) el[j].selected = true;
					else el[j].checked = true;
				}
			}
		}
	}
}

function characterCountdown(obj, used_char_id, max_char) {
	var len = obj.value.length;
	max_char = parseInt(max_char);
	if (len > max_char) {
		obj.value = obj.value.substring(0, max_char);
	} else {
		$('#' + used_char_id).text(max_char - len);
	}
}

//FAQ page

/**
 * Add a document.ready call as a hook to add to the FAQ sitedoc
 */
function prepFAQ() {
	$(document).ready(function () {
		loadFAQ();
	});
}
/**
 * Actual FAQ work is done. Exists as a separate function so that it can be called separately when the FAQs are loaded in a modal window.
 * a) conceal all answers
 * b) bind slidedown / up function to each question
 */
function loadFAQ() {
	$(".js-faq-answer").hide();
	$(".js-faq-question").removeClass("c-faq-question--is-open openQuestion");
	$(".js-faq-question__question-text").on("click", function () {
		var $toggler = $(this).closest(".js-faq-question");;
		var $toggled = $toggler.find(".js-faq-answer");
		if ($($toggled).is(":hidden")) {
			$toggler.addClass("c-faq-question--is-open openQuestion");
			$toggled.slideDown({
				duration: 300
			});
		} else {
			$toggled.slideUp({
				duration: 300,
				complete: function () {
					$toggler.removeClass("c-faq-question--is-open openQuestion");
				}
			});
		}
	});
	/**
	 * Check whether there's a hash in the URL. If so, check for an element of matching ID that also has class "individualQuestion" and open it if it exists.
	 * Some browsers include the # in window.location.hash while some don't
	 */
	var hashval = window.location.hash.replace('#', '');
	if (hashval != "" && ($("#" + hashval + ".js-faq-question").length > 0)) {
		$("#" + hashval).addClass("openQuestion");
		$("#" + hashval + " .js-faq-answer").show();
	}
}


/* Smooth Scrolling functions */
function currentYPosition() {
	// Firefox, Chrome, Opera, Safari
	if (self.pageYOffset) {
		return self.pageYOffset;
	}
	// Internet Explorer 6 - standards mode
	if (document.documentElement && document.documentElement.scrollTop) {
		return document.documentElement.scrollTop;
	}
	// Internet Explorer 6, 7 and 8
	if (document.body.scrollTop) {
		return document.body.scrollTop;
	}
	return 0;
}

function elmYPosition(eID) {
	var elm = getObById(eID);
	var y = elm.offsetTop;
	var node = elm;
	while (node.offsetParent && node.offsetParent != document.body) {
		node = node.offsetParent;
		y += node.offsetTop;
	}
	return y;
}

function smoothScroll(eID) {
	var startY = currentYPosition();
	var stopY = elmYPosition(eID);
	var distance = stopY > startY ? stopY - startY : startY - stopY;
	if (distance < 100) {
		scrollTo(0, stopY); return;
	}
	var speed = Math.round(distance / 100);
	if (speed >= 20) {
		speed = 20;
	}
	var step = Math.round(distance / 25);
	var leapY = stopY > startY ? startY + step : startY - step;
	var timer = 0;
	if (stopY > startY) {
		for (var i = startY; i < stopY; i += step) {
			setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
			leapY += step; if (leapY > stopY) leapY = stopY; timer++;
		}
		return;
	}
	for (var i = startY; i > stopY; i -= step) {
		setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
		leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
	}
}

// DWilliams Collapsing divs on Brand pages

function setupCollapse() {
	$(document).ready(function () {
		$descExcerpt = $("#brandExcerpt");
		$descFullDesc = $("#brandFullDesc");
		if ($descExcerpt.length > 0 && $descFullDesc.length > 0) {
			$descFullDesc.hide();
			// Select last direct child element
			$("> :last", $descExcerpt).append(' <a id="descReadMore" href="#">' + brandsReadMore + '</a>');
			$("#descReadMore").on("click", function (e) {
				e.preventDefault();
				$(this).hide();
				$descFullDesc.show();
			});
		}
	});
}


/*
 * 14. Auto Re-Order
 */

/**
	* Function to Show the Auto Re-Order on the basket
	* Called on an onclick on the yes radio button
	*
	* @param string nonDailyDuration
	*
	* nonDailyDuration will be an empty string if the longest duration in the basket is dailies
	* or accessories and we will show the dropdown instead of the datepicker.
	*
	* otherwise the nonDailyDuration will be the duration of the lenses in the basket and the
	* datepicker will be shown with the calculated date selected.
	*
 **/
function showAutoReorder(nonDailyDuration, duration) {
	handleReplenishDate();

	// Davidwilliams: Show AR Paypal message (on R&P)
	$('.js-ara-paypal').addClass('visible');
	$(".js-ara-unavailable-message").show();

	managePaypalAdvancedPaymentsSaveCardVisibility(true);

	// LisaKelly: Display the reorder container
	$('#reorderContainer').addClass('show');
	// LisaKelly: Display the datepicker if it is a non-daily/accessory basket
	if (nonDailyDuration != '') {
		$('#dateDisplay').show();
		$('#datepicker').show();

		// LisaKelly: Calculate the date to display
		var dateDisplay = calculateDate(parseInt(nonDailyDuration));
		$('#interval').val(nonDailyDuration);
		$('#originalInterval').val(nonDailyDuration);
		$('#dateText').html(sprintf(dateText, nonDailyDuration));
		$('#date').html(dateDisplay);
		$('#intervalText').html(sprintf(intervalText, nonDailyDuration));
		// LisaKelly: Update the session with the Auto Re-Order Data as there is no dropdown
		updateAutoReorderData();
	} else {
		// LisaKelly: Show the dropdown for daily/accessory basket
		$('#dropdown').show();
	}
	// LisaKelly: Fire GA event
	GA_Event_Trigger("Auto Re-Order", "click - box", "Yes");
	$('#remember_card').attr({
		readonly: "readonly",
		onclick: "return false;",
		onkeydown: "return false;",
		checked: "checked"
	});
	$('#stored_card_required').show();
}

/**
	* Function to hide and unset the Auto Re-Order on the basket
	* Called on an onclick on the no radio button
	*
 **/
function hideAutoReorder(duration) {
	// Davidwilliams: Hide AR Paypal message (on R&P)
	$('.js-ara-paypal').removeClass('visible');
	$(".js-ara-unavailable-message").hide();

	managePaypalAdvancedPaymentsSaveCardVisibility();

	// LisaKelly: Hide the elements dropdown/datepicker/dateDisplay
	$('#reorderContainer').removeClass('show');
	if ($('#dropdown').length) {
		// LisaKelly: If the duration is empty it is an accessory only basket
		$('#dropdown').hide();
	}
	$('#dateDisplay').hide();
	$('#datepicker').hide();
	// LisaKelly: Unset the hidden input fields of interval and intervalUseRate
	$('#interval').val(0);
	$('#intervalUseRate').val(0);
	// LisaKelly: Unset the originalInterval and the dropdown select if it exists
	$('#originalInterval').val(0);
	$('#dropdownSelect').val(0);
	$('#modalityMakeup').val(0);
	$('#original_original_interval').val(0);
	// LisaKelly: Call updateAutoReorderData to unset the interval and intervalUseRate in the session
	updateAutoReorderData();
	/// LisaKelly: Change the Checkout button back

	// LisaKelly: Fire GA event
	GA_Event_Trigger("Auto Re-Order", "click - box", "No");
	$('#remember_card').attr({ readonly: null, onclick: null, onkeydown: null });
	$('#stored_card_required').hide();
}
/**
	* Function to handle the Auto Re-Order dropdown on the basket
	* Called on an onchange on the dropdown
	*
	* @param string duration
	*
	* duration will be an empty string if it is an accessories only basket
	*
	* otherwise the duration will be the duration of the daily lenses in the basket.
	*
 **/
function dropdownAction(duration) {
	// LisaKelly: Get the option name for display
	var optionName = $('#dropdownSelect option:selected').html();
	// LisaKelly: Get the option value for the date calculation
	var option = parseInt($('#dropdownSelect').val());

	// LisaKelly: Fire GA event
	GA_Event_Trigger("Auto Re-Order", "Selected", optionName);

	// LisaKelly: If there is no duration it is an accessory only basket
	if (option === 0) {
		$('#dateDisplay').hide();
		$('#datepicker').hide();

		return false;
	}

	var dateDisplay = calculateDate(option);

	if (duration !== '') {
		option = Math.round(duration * (7 / option));
		dateDisplay = calculateDate(option);
	}

	$('#originalInterval').val(option);
	// LisaKelly: Display the date text
	$('#dateText').html(sprintf(dateText, optionName));
	$('#date').html(dateDisplay);
	$('#intervalText').html(sprintf(intervalText, $('#interval').val()));
	// LisaKelly: Get the use rate selected in the dropdown
	$('#intervalUseRate').val($('#dropdownSelect')[0].selectedIndex);
	// LisaKelly: One the date calculation has been done display the datepicker and the dateDisplay
	$('#dateDisplay').show();
	$('#datepicker').show();

	// LisaKelly: Update the session with the Auto Re-Order Data as we now have a selection in the dropdown
	updateAutoReorderData();
}
/**
	* Function to change the date and calculate new interval
	* Called on an onchange on the native datepicker
	*
	* @param dateFormat of datepicker selectedDate e.g. 17 July 2013
	*
 **/
function changeDate(selectedDate) {
	var config = window.replenishDateConfig || {};
	var errors = config.errors || {};

	if (!selectedDate) {
		$('#date').html(errors.empty);
		$('#intervalText').html('');

		return false;
	}

	var min = getReplenishDate('min');
	var today = DateTime.today();
	var minDate = DateTime.parse(min);
	var newDate = DateTime.parse(selectedDate);

	// Make sure that manual entry date isn't in the past
	if (newDate.unix() < minDate.unix()) {
		$('#date').html(errors.outdated);
		$('#intervalText').html('');

		return false;
	}

	// Sync time
	today.hours(newDate.hours());
	today.minutes(newDate.minutes());
	today.seconds(newDate.seconds());

	// Get the difference between today and the selected Date, ms per day
	var diff = (newDate.unix() - today.unix()) / (60 * 60 * 24);
	diff = Math.round(diff);

	if (isNaN(diff)) {
		$('#date').html(errors.invalid);
		$('#intervalText').html('');

		return false;
	}

	// Convert the new date to the selected format for display
	newDate = DateTime.format(null, newDate);

	$('#date').html(newDate);
	$('#intervalText').html(sprintf(intervalText, diff));
	$('#interval').val(diff);

	// Update session with the AutoRe-Order Data as date changed in datepicker
	updateAutoReorderData();
}

/**
	* Function to calculate the new date and update the datepicker accordingly
	* Called just before showing the datepicker on the basket
	*
	* @param string calculation
	*
	* calculation is the duration of the basket if it is non-daily lenses
	* calculation is the duration of the dropdown if it is accessory only
	* calculation is duration * (7/option) if it is daily lenses
	*
	* @return dateFormat EEEE, d MMMM yyyy date to display e.g. Monday, 05 August 2013
	*
 **/
function calculateDate(calculation) {
	$('#interval').val(calculation);

	var date = setReplenishDate(calculation);
	date = DateTime.format(null, date);

	return date;
}

/**
 * Function to send the Auto Re-Order details using ajax from the basket
 * Called from the Check Out Now button if it is setting up an Auto Re-Order
 * Also called from hideAutoReorder() to send the unset of the interval and
 * intervalUseRate
 *
 * @return jquery ajax object
 *
 */
function updateAutoReorderData() {
	var interval = $('#interval').val();
	var intervalUseRate = $('#intervalUseRate').val();
	var modalityMakeup = $('#modalityMakeup').val();
	var newRecommendedInterval = $('#newRecommendedInterval').val();
	var originalInterval = $('#originalInterval').val();

	if (newRecommendedInterval > 0) {
		originalInterval = newRecommendedInterval;
	}

	return $.ajax({
		url: rootURL,
		type: 'POST',
		async: true,
		data: {
			_g: 'ex',
			type: 'autoReorderData',
			rand: Math.random(),
			interval: interval,
			intervalUseRate: intervalUseRate,
			originalInterval: originalInterval,
			modalityMakeup: modalityMakeup
		}
	});
}

/**
 * Function to send the Auto Re-Order decision made using ajax
 * Called from checkoutSubmit if Auto Re-Order is on the page
 *
 * @return jquery ajax object
 *
 */
function updateAutoReorderDecision() {
	return $.ajax({
		url: rootURL,
		type: 'GET',
		async: true,
		data: {
			_g: 'ex',
			type: 'autoReorderData',
			autoReOrderDecision: 1,
			rand: Math.random()
		}
	});
}

function handleReplenishDate(options) {
	options = options || {};

	var input = document.querySelector('#replenish-date');
	input.setAttribute('pattern', '(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))'); // set pattern in JS as PHP strips out {}

	if (!input) {
		return false;
	}

	var format = input.getAttribute('data-format');

	if (!format) {
		format = 'YYYY-MM-DD';
	}

	// Set value as tomorrow's date
	var min = DateTime.tomorrow();

	if (options.min) {
		min = options.min;
	}

	min = DateTime.format(format, min);
	input.value = min;

	if (options.value) {
		input.value = DateTime.format(format, options.value);
	}

	// Set min value as tomorrow's date
	input.setAttribute('min', min);

	// Set max value with 10 years in future
	var max = DateTime.today().add(10, 'years');

	if (options.max) {
		max = options.max;
	}

	max = DateTime.format(format, max);
	input.setAttribute('max', max);

	// Attach event handlers
	var onchange = function () {
		changeDate(this.value);
	};

	if (typeof options.onchange === 'function') {
		onchange = options.onchange;
	}

	input.onchange = onchange;
	input.onkeyup = onchange;
}

function getReplenishDate(type) {
	var input = document.querySelector('#replenish-date');

	if (!input) {
		return '';
	}

	var value = input.value;

	if (type === 'min') {
		value = input.getAttribute('min')
	}

	if (type === 'max') {
		value = input.getAttribute('max')
	}

	return value;
}

function setReplenishDate(days) {
	var input = document.querySelector('#replenish-date');

	if (!input) {
		return false;
	}

	var format = input.getAttribute('data-format');

	if (!format) {
		format = 'YYYY-MM-DD';
	}

	var date = DateTime.now().add(days, 'days');
	input.value = DateTime.format(format, date);

	return date;
}

/**
 * Function to display the Auto Re-Order details on the basket
 * Called when a change button that goes to the basket page from the submit order page
 * The session needs to have the autoReorder set for this to be called
 *
 */
function displayAutoReorder() {
	handleReplenishDate();

	// LisaKelly: Make the yes radio button checked
	$('#reorder_yes').prop('checked', true);

	$(document).ready(function () {
		$('#reorder_yes').trigger('click');
	})

	// LisaKelly: Display the reorder container
	$('#reorderContainer').addClass('show');
	// LisaKelly: Check if we need to display the dropdown selected
	if (intervalUseRate != "" && intervalUseRate != 0) {
		$('#dropdown').show();
		getObById('dropdownSelect').options[intervalUseRate].selected = true;
		$('#intervalUseRate').val(intervalUseRate);
		$('#dateText').html(sprintf(dateText, $('#dropdownSelect option:selected').html()));
	} else {
		$('#dateText').html(sprintf(dateText, nonDailyDuration));
	}
	$('#dateDisplay').show();
	// LisaKelly: Calculate the date to be displayed
	var dateDisplay = calculateDate(parseInt(interval));
	$('#date').html(dateDisplay);
	$('#datepicker').show();
	$('#intervalText').html(sprintf(intervalText, interval));
}

function showDeliveryAddresses() {
	if (!$('#showAddresses').length) {
		deliveryAddressId = parseInt($('#deliveryAddressId').val());
		var xmlHttp = getXMLHttp();
		xmlHttp.onreadystatechange = function () {
			if (xmlHttp.readyState == 4) {
				$("#reorderDeliveryAddress").html('<div id="addresses"><div id="showAddresses"></div></div>');
				$("#showAddresses").html(xmlHttp.responseText);
				$('#addAddress').appendTo($("#addresses"));
				$('#addAddress').hide();
				$("#confirmCancelDeliveryAddress").show();
				$('#deliveryChangeAddress').show();
			}
		}
		xmlHttp.open("GET", rootURL + '\/\?\_g\=ex\&type\=getDeliveryAddress\&deliveryAddressId\=' + deliveryAddressId + '\&rand\=' + Math.random(), true);
		xmlHttp.send(null);
	}
}

function closeDeliveryChange() {
	$("#addAddress").appendTo("#addAutoReOrderAddress");
	$("#reorderDeliveryAddress").empty();
	$("#confirmCancelDeliveryAddress").hide();
}

$(document).ready(function () {
	$('.js-show-billing-information').on('click', function (event) {
		var href = event.currentTarget.getAttribute('href');

		if (href === '#') {
			event.preventDefault();
		}

		$('html, body').animate({
			scrollTop: $('#addressBillingBlock').offset().top
		}, 1000);
	});

	$('.js-change-billing-information, .js-change-interval, .js-change-re-order-name').on('click', function (event) {
		var href = event.currentTarget.getAttribute('href');

		if (href === '#') {
			event.preventDefault();
		}

		var target = $(this).data('target');
		var $target = $(target);

		if (!$target.is(':visible')) {
			$target.show();

			if (!!window.PaymentHandler) {
				PaymentHandler.selectAvailablePaymentOption();
			}
		} else {
			$target.hide();
		}
	});

	$('.js-change-re-order-date').on('click', function (event) {
		var href = event.currentTarget.getAttribute('href');

		if (href === '#') {
			event.preventDefault();
		}

		var target = $(this).data('target');
		var $target = $(target);

		if (!$target.is(':visible')) {
			showNextAutoReorder();
			$target.show();
		} else {
			$target.hide();
		}
	});

	if ($('#appointment_date').length) {
		selectPreferredAppointmentDate();
	}
});

function selectPreferredAppointmentDate() {
	var min = DateTime.create({
		year: preferredAppointmentOptions.firstOpenYear,
		month: preferredAppointmentOptions.firstOpenMonth - 1,
		day: preferredAppointmentOptions.firstOpenDay
	});

	var max = DateTime.today();
	max.month(max.month() + preferredAppointmentOptions.maxMonthsAhead);

	// Set event handler
	var onchange = function () {
		updateAppointmentDate(this.value)
	};

	handleReplenishDate({
		min: min,
		max: max,
		onchange: onchange
	});

	setAppointmentSlots(getReplenishDate('min'));
}

function updateAppointmentDate(selectedDate) {
	if (!selectedDate) {
		return false;
	}

	var min = getReplenishDate('min');
	var max = getReplenishDate('max');
	var today = DateTime.today();
	var minDate = DateTime.parse(min);
	var maxDate = DateTime.parse(max);
	var newDate = DateTime.parse(selectedDate);

	// Make sure that manual entry date isn't in the past
	if (newDate.unix() < minDate.unix()) {
		return false;
	}

	// Sync time
	today.hours(newDate.hours());
	today.minutes(newDate.minutes());
	today.seconds(newDate.seconds());

	// Calculate the max selectable days in the future for appointments
	var maxSelectDays = (maxDate.unix() - newDate.unix()) / (60 * 60 * 24);

	if (maxSelectDays < 0) {
		return false;
	}

	// Get the difference between today and the selected Date, ms per day
	var diff = (newDate.unix() - today.unix()) / (60 * 60 * 24);
	diff = Math.round(diff);

	if (isNaN(diff)) {
		return false;
	}

	GA_Event_Trigger('Appointment Request', 'Selected Date', diff + ' days from today');

	setAppointmentSlots(selectedDate);
	clearTimeslotValues();
}

/**
	* Function to display the dialogs
	* Called when certain change buttons are selected on the viewAutoReOrders page
	* Called when the Find out more link on the basket and viewAutoReOrders page is clicked
	* Called by the other js functions before other calculations
	*
	* @param string reorderId
	* @param string reorderWidth
	* @param string reorderName (optional)
	* @param string reorderValue (optional)
	*
	* 'reorder-info-dialog', 500
	* 'cardError', 500
	* 'prescriptionError', 800
	* 'name-dialog', 500, 'reorderName', '{VAL_AUTO_REORDER_NAME}'
	* 'interval-dialog', 500, 'reorderInterval', '{VAL_INTERVAL}'
	* 'delivery-dialog', 500
	* 'date-dialog', 500
	* 'order-dialog', 700
	* 'card-dialog', 800
	*
 **/
function openADialog(dialogId, dialogWidth, dialogHeight, autoOpenVal, draggable) {
	var heightValue = (typeof dialogHeight === "undefined") ? "auto" : dialogHeight;
	var autoOpenVal = (typeof autoOpenVal === "undefined") ? "true" : autoOpenVal;
	var draggable = (typeof draggable === "undefined") ? false : draggable;

	$(function () {
		$("#" + dialogId).dialog({
			width: dialogWidth,
			height: heightValue,
			autoOpen: autoOpenVal,
			draggable: draggable,
			modal: true,
			show: {
				effect: 'drop',
				direction: "up"
			},
			position: {
				my: "center top",
				at: "top+50",
				of: window
			}
		});
	});
	if (dialogId == 'confirmation-dialog') {
		$("#" + dialogId).dialog({
			open: function (event, ui) {
				$(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
			},
			draggable: draggable,
			closeOnEscape: false,
			resizable: false,
			modal: true,
			position: {
				my: "center top",
				at: "top+50",
				of: window
			}
		});
	}
}

function showNextAutoReorder() {
	var $disabled = $('#todayDisabled');
	var min = DateTime.today();
	var max = $('#future_timestamp').val();
	max = DateTime.parse(max);
	var value = $('#timestamp').val();
	value = DateTime.parse(value);
	var date = DateTime.format(null, value);

	if ($disabled.length && parseInt($disabled.val()) === 1) {
		min = DateTime.tomorrow();
	}

	// Set event handler
	var onchange = function () {
		updateDate(this.value);
	};

	handleReplenishDate({
		value: value,
		min: min,
		max: max,
		onchange: onchange
	});

	$('#dateDisplay').html(date);
	$('#datepicker').show();
}


/**
	* Function to update the date and check if it is today
	* Called on an onSelect on the datepicker on the openDateDialog()
	*
	* @param dateFormat of datepicker selectedDate e.g. 17 July 2013
	*
 **/
function updateDate(selectedDate) {
	var config = window.replenishDateConfig || {};
	var errors = config.errors || {};

	if (!selectedDate) {
		$('#dateDisplay').html(errors.empty);

		return false;
	}

	var min = getReplenishDate('min');
	var today = DateTime.today();
	var minDate = DateTime.parse(min);
	var newDate = DateTime.parse(selectedDate);

	// Make sure that manual entry date isn't in the past
	if (newDate.unix() < minDate.unix()) {
		$('#dateDisplay').html(errors.outdated);

		return false;
	}

	// Sync time
	today.hours(newDate.hours());
	today.minutes(newDate.minutes());
	today.seconds(newDate.seconds());

	// Get the difference between today and the selected Date, ms per day
	var diff = (newDate.unix() - today.unix()) / (60 * 60 * 24);
	diff = Math.round(diff);

	if (isNaN(diff)) {
		$('#dateDisplay').html(errors.invalid);

		return false;
	}

	// If today's date is selected, take visitor to new page
	if (diff < 1 && confirm(confirm_message)) {
		var redirect = $('#newReorderDate').data("update-url");
		window.location = redirect;

		return false;
	}

	// Convert the new date to the selected format for display
	var newdateDisplay = DateTime.format(null, newDate);
	var timestamp = DateTime.format('YYYY-MM-DD', newDate);

	// Update the display with the newly selected date
	$('#timestamp').val(timestamp);
	$('#dateDisplay').html(newdateDisplay);
}

/**
	* Function to display the order dialog
	* Called when the next order date change button is selected on the viewAutoReOrders page
	* and today has been selected in the datepicker
	*
	* Allows the customer to place an ad-hoc Auto Re-Order
	*
 **/
function openOrderDialog() {
	/* LisaKelly: confirm_message is a js global variable to confirm you wish to create an ad-hoc order */
	if (confirm(confirm_message)) {
		$('#createOrderButton').unbind('click');
		/* Lisakelly: Get the details form the viewAutoReOrders page to display in the dialog */
		$('#placeOrder').html($('#orderDetails').html());
		$('#placeOrderCard').html($('#cardDetails').html());
		/* Davidwilliams delete duplicate ID. */
		$('#placeOrderCard .cardChangeHolder').remove();
		if ($('#cardDetails').data("enabled") === 1) {
			$('#createOrderButton').on("click", function () {
				createOrder();
			});
			$('#createOrderButton').prop("disabled", false);
		} else {
			$('#createOrderButton').prop("disabled", true);
		}
		$("#placeOrderDeliveryContent").html('');
		$("#deliveryDetails .orderDetailsContent").clone().appendTo("#placeOrderDeliveryContent");
		$("#placeOrderBillingContent").html('');
		$("#billingDetails .orderDetailsContent").clone().appendTo("#placeOrderBillingContent");
		openADialog('order-dialog', 700);
		return false;
	}
	else {
		return false;
	}
}
/**
	* Function to close the dialogs
	* Called on an onclick on the Close button in the dialog
	*
 **/
function closeReOrderDialog(dialogId, reloadPage) {
	if (typeof ('#addAutoReOrderAddress') != 'undefined') {
		// LisaKelly: Move the addAddress form back to the holder container
		$("#addAddress").appendTo("#addAutoReOrderAddress");
		// Empty the address blocks
		$("#reorderDeliveryAddress").empty();
		$("#reorderBillingAddress").empty();
	}
	$("#" + dialogId).dialog("close");
	if (reloadPage == true) {
		document.location.reload(true);
	}
}

/**
	*
	* Function to create an ad-hoc Auto Re-Order order
	* Called from an onClick on today in the datepicker in the viewAutoReOrder page
	*
 **/
function createOrder() {
	// show uk loading img
	var ukSpinner = $('#createOrderSpinner');
	var ukButton = $('#createOrderButton');
	// DE confirm button - view ARTodayDE hack
	var deButton = $('.createOrderButtonDE');

	ukSpinner.show(0).css('display', 'inline');

	if (!deButton.length) {
		ukButton.hide();
	} else {
		deButton.addClass('c-button--is-loading');
	}

	var autoReOrderId = $('#newOrder').val();
	var xmlhttp = getXMLHttp();
	var parameters = "&auto_reorder=" + autoReOrderId;
	xmlhttp.onreadystatechange = function () {
		if (xmlhttp.readyState == 4) {
			if (xmlhttp.status == 403 && xmlhttp.statusText == 'Not logged in') {
				document.location.href = document.location.href.split('#')[0];
			} else if (xmlhttp.responseText.indexOf("prescription_error") != -1) {
				/* Display prescription_expired dialog */
				ukSpinner.hide();
				ukButton.show();

				deButton.removeClass('c-button--is-loading');

				$('#prescriptionErrorDisplay').html(prescription_expired);
				$('#prescriptionError').attr("title", prescription_expired_title);
				closeReOrderDialog('order-dialog');
				openADialog('prescriptionError', 800);
			} else if (xmlhttp.status == 200) {
				/* Display confirmed dialog */
				ukSpinner.hide();
				ukButton.show();

				deButton.addClass('c-button--is-disabled');

				$('#confirm_order').html(xmlhttp.responseText);
				closeReOrderDialog('order-dialog');
				openADialog('confirmation-dialog', 500);
			} else {
				/* Display error dialog */
				ukSpinner.hide();
				ukButton.show();

				deButton.removeClass('c-button--is-loading');

				$('#cardErrorDisplay').html(xmlhttp.responseText);
				$('#cardError').attr("title", payment_declined_title);
				closeReOrderDialog('order-dialog');
				openADialog('cardError', 500);
			}
		}
	};
	xmlhttp.open("POST", siteroot + "/?_g=ex&type=createAutoReOrder&rand=" + Math.random(), true);
	xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	xmlhttp.send(parameters);
	return false;
}

function sendGAFindOutMoreEvent(duration) {
	GA_Event_Trigger("Auto Re-Order", "click - box", "Find Out More");
}

//Asafisk - Seamless 2 - Load widget via AJAX and show in ID'd container element /
function widgetFadeIn(siteroot, elid, widget, params) {
	if (widget) {
		loadWidgetHTML(siteroot, elid, widget, params);
	}
}

//Asafisk - Seamless 2 - Re-Load widget via AJAX and show in ID'd container element /
function reloadWidgetFadeIn(siteroot, elid, widget, params) {
	if (widget) {
		setTimeout(function () {
			loadWidgetHTML(siteroot, elid, widget, params);
		}, 200);
	}
}

function loadWidgetHTML(siteroot, elid, widget, params) {
	var xmlHttp = getXMLHttp();

	xmlHttp.onreadystatechange = function () {
		if (xmlHttp.readyState == 4 && xmlHttp.status == 403 && xmlHttp.statusText == 'Not logged in') {
			document.location.href = document.location.href;
		} else if (xmlHttp.readyState == 4) {
			insertWidgetHTML(elid, xmlHttp.responseText);
		}
	}

	//Ensure root ends in a '/'
	if (siteroot.slice(-1) != '/') {
		siteroot = siteroot + '/';
	}

	if ( $('body').hasClass('js-is-spain') ) {
		//Send the proper header information along with the request
		xmlHttp.open('POST', siteroot + '?_g=ex&_a=widget&rand=' + Math.random(), true);
		xmlHttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		xmlHttp.send('box=' + widget + '&params=' + params);
	} else {
		xmlHttp.open("GET", siteroot + "?_g=ex&_a=widget&box=" + encodeURIComponent(widget) + "&params=" + encodeURIComponent(params) + "&rand=" + Math.random(), true);
		xmlHttp.send(null);
	}
	return false;
}

function insertWidgetHTML(elid, widgetHTML) {
	$('#' + elid).html(widgetHTML);
	$('#' + elid).show();
	removeWaitingOverlay(elid);
}

function reloadWidgetFadeInArray(arr) {
	for (w = 0; w < arr.length; w++) {
		var widgetOb = arr[w];
		var cParams = "";
		if (widgetOb.couponParams) {
			cParams = JSON.stringify(widgetOb.couponParams);
		}
		reloadWidgetFadeIn(widgetOb.couponSiteroot, widgetOb.couponElid, widgetOb.couponWidget, cParams);
	}
}

/* Create a new, absolutely positioned, full width and length div and append it to the element being changed.
 * If the changing element has a background-color, set the new div's background color to match.
 * Remove any checkoutOverlay already appended, just in case we have duplicates.
 */
function applyWaitingOverlay(elid) {
	removeWaitingOverlay(elid);
	$('<div></div>', {
		"class": 'waitingTransitionOverlay c-waiting-transition-overlay',
		id: elid + "TransitionOverlay"
	}).appendTo("#" + elid);
	if (($("#" + elid).css("background-color") != "transparent") && ($("#" + elid).css("background-color") != 'rgba(0, 0, 0, 0)')) {
		$("#" + elid + " .waitingTransitionOverlay").css("background-color", $("#" + elid).css("background-color"));
	}
}
function removeWaitingOverlay(elid) {
	$("#" + elid + " .waitingTransitionOverlay").remove();
}
function applyWaitingOverlayToArr(arr) {
	for (var d = 0; d < arr.length; d++) {
		applyWaitingOverlay(arr[d]);
	}
}
// LisaKelly: jQuery function to replace javascript confirm()
(function ($) {
	$.confirm = function (params) {
		var defer = $.Deferred();
		$('<div></div>').appendTo('body')
			.html('<div><p>' + params.message + '</p></div>')
			.dialog({
				modal: true,
				title: params.title,
				autoOpen: true,
				width: "500",
				dialogClass: "no-close",
				position: {
					my: "center",
					at: "top+250",
					of: window
				},
				buttons: [
					{
						text: confirmYes,
						class: "c-button",
						click: function () {
							defer.resolve(true);
							$(this).dialog("close");
						}
					},
					{
						text: confirmNo,
						class: "c-button",
						click: function () {
							defer.resolve(false);
							$(this).dialog("close");
						}
					}
				],
				close: function () {
					$(this).remove();
				}
			});
		return defer.promise();
	}
})(jQuery);


/**
 * 17. Show / edit address
 **/

function showEditWarning(lastFourDigits, siteroot, params) {
	$.confirm({ 'title': confirmTitleEdit, 'message': sprintf(confirmTextWarning, lastFourDigits) }).then(function (answer) {
		if (answer) {
			showEditAddress(siteroot, params);
		}
	});
}


function showEditAddress(siteroot, params) {
	clearValidateResults(newAddressVals["mode"], newAddressVals["error_container_id"]);
	//populate the address fields
	var xmlhttp = getXMLHttp();
	xmlhttp.onreadystatechange = function () {
		if (xmlhttp.readyState == 4 && xmlhttp.status == 403 && xmlhttp.statusText == 'Not logged in') {
			document.location.href = document.location.href;
		} else if (xmlhttp.readyState == 4) {
			var response = JSON.parse(xmlhttp.responseText);
			$("#addAddress").show();
			capturePlusInit();

			if ($('#postcodeLookup').length) {
				onScreenAddressFields();
				$('#selectAddress').hide();
				$('#searchInput').val('');
			}

			// Check for packstation functionality
			if ($("#packstation").length) {
				$("input[name=packstationRadio][value=" + response['packstation'] + "]").prop("checked", true);
				//changeAddressValidation called from here
				changeAddressFields();
				$("#packstation").val(response['packstation']);
			} else {
				changeAddressValidation();
			}

			$("#name").val(response['name']);
			$("#company").val(response['company']);
			$("#add_1").val(response['add_1']);
			$("#add_2").val(response['add_2']);
			$("#town").val(response['town']);
			$("#county").val(response['county']);
			$("#postcode").val(response['postcode']);
			$("#country").val(response['country']);
			$("#addAddressId").val(response['address_id']);
			$("#addressSubmitHidden").remove();
			$("#addAddressTitle").html(editText);
			$("#addressSubmit").html(editText);
			$('html, body').animate({
				scrollTop: $("#addAddress").offset().top
			}, 1000);
		}
	}
	xmlhttp.open("GET", siteroot + "/?_g=ex&type=showEditAddress&params=" + params + "&rand=" + Math.random(), true);
	xmlhttp.send(null);
}


function showAddAddress(siteroot) {
	clearValidateResults(newAddressVals["mode"], newAddressVals["error_container_id"]);
	hideMessageBoxes();
	if ($('#postcodeLookup').length) {
		$('#searchInput').val('');
		$("#addressFields").addClass("addressFieldsOffScreen c-address-fields-offscreen");
		$('#postcodeLookup').show();
		$('#manualEntry').show();
		$('#PCAcancel').show();
		$('#selectAddress').hide();
		$('#searchResults').hide();
	} else {
		addressDisableCheckoutSubmit();
	}

	// Check for packstation functionality
	if ($("#packstation").length) {
		$("input[name=packstationRadio][value=0]").prop("checked", true);
		changeAddressFields();
	} else {
		changeAddressValidation();
	}

	$("#name").val(customer_name);
	$("#country").val(default_country);
	$("#company").val('');
	$("#add_1").val('');
	$("#add_2").val('');
	$("#town").val('');
	$("#county").val('');
	$("#postcode").val('');
	$("input[name=addressId]").remove();
	$("#addAddressTitle").html(addTitleText);
	$("#addressSubmit").html(addText);
	$("#addAddressId").val(0);
	$('#addAddress').slideDown({
		duration: 200,
		complete: function () {
			capturePlusInit();

			// Check whether the PostcodeAnywhere input is present. If so, assign focus, otherwise assign focus to first input element of type text within #addressFields
			var addressSearch = $("#searchInput");
			if (addressSearch.length > 0) {
				addressSearch.focus();
			} else {
				$("#addressFields input:text").eq(0).focus();
			}
		}
	});
	$('html, body').animate({
		scrollTop: $("#addAddress").offset().top
	}, 1000);
}

function hideAddEditAddress() {
	clearValidateResults(newAddressVals["mode"], newAddressVals["error_container_id"]);
	hideMessageBoxes();
	$('#searchInput').val('');
	$('#selectAddress').hide();
	$("#addAddress").slideUp({
		duration: 200
	});
	addressEnableCheckoutSubmit();
	return false;
}

/* Setup the Capture+ listeners - wait until the DOM is ready and CapturePlus script has loaded */
function initPca() {
	if (!$('.js-address-lookup-input').length) {
		return false;
	}

	if (typeof pca === 'undefined') {
		return false;
	}

	pca.on("load", function (type, id, control) {
		control.listen('populate', function () {
			onScreenAddressFields();
			changeAddressValidation();
			GA_Event_Trigger('Address Finder', 'Select Address', '');
		});

		control.listen('error', function (message) {
			var errorType = 'Silent';

			if (message !== 'No response' && message !== 'Country Invalid') {
				$('#capturePlusError').show();

				onScreenAddressFields();
				$('#add_1').focus();

				$('html, body').animate({
					scrollTop: $('#capturePlusError').offset().top
				}, 1000);

				errorType = 'Displayed';
			}

			GA_Event_Trigger('Address Finder', 'Error', errorType);

			$.ajax({
				url: rootURLProt + '?_g=ex&type=capturePlusError&rand=' + Math.random(),
				type: 'POST',
				async: true,
				data: {
					errorText: message,
					currentPage: window.location.href,
					searchTerms: $('#searchInput').val(),
					searchCountry: $('#country').val(),
					source: scriptSource
				}
			});
		});
	});
}


function capturePlusInit() {
	// Don't initialize Capture Plus if the address search field is not available or visible on the page
	if (!$('.js-capture-plus-address').length || !$('.js-capture-plus-address').is(':visible') || typeof window.capturePlus !== 'undefined') {
		return false;
	}

	if (typeof window.capturePlusOptions === 'undefined' || !Object.keys(window.capturePlusOptions).length) {
		return false;
	}

	var head = document.getElementsByTagName('head')[0];
	var link = document.createElement('link');
	var script = document.createElement('script');
	var options = window.capturePlusOptions;

	link.rel = 'stylesheet';
	link.type = 'text/css';
	link.href = [options.style, options.key].join('?key=');

	script.defer = true;
	script.src = [options.script, options.key].join('?key=');

	head.appendChild(link);
	head.appendChild(script);

  retryScriptExecution('capturePlus', capturePlusSetup);
}

// Setup the Capture+ listeners - wait until the DOM is ready and CapturePlus script has loaded
function capturePlusSetup() {
	if (typeof window.capturePlus === 'undefined') {
		return false;
	}

	capturePlus.listen('populate', function () {
		onScreenAddressFields();
		changeAddressValidation();
		GA_Event_Trigger('Address Finder', 'Select Address', '');
	});

	capturePlus.listen('error', function (message) {
		var errorType = 'Silent';

		if (message !== 'No response' && message !== 'Country Invalid') {
			$('#capturePlusError').show();

			onScreenAddressFields();
			$('#add_1').focus();

			$('html, body').animate({
				scrollTop: $('#capturePlusError').offset().top
			}, 1000);

			errorType = 'Displayed';
		}

		GA_Event_Trigger('Address Finder', 'Error', errorType);

		$.ajax({
			url: rootURLProt + '?_g=ex&type=capturePlusError&rand=' + Math.random(),
			type: 'POST',
			async: true,
			data: {
				errorText: message,
				currentPage: window.location.href,
				searchTerms: $('#searchInput').val(),
				searchCountry: $('#country').val(),
				source: scriptSource
			}
		});
	});
}


/* Shift address fields from being positioned off-page */
function onScreenAddressFields() {
	$("#addressFields").removeClass("addressFieldsOffScreen c-address-fields-offscreen");
	$('#manualEntry').hide();
	$('#PCAcancel').hide();
	addressDisableCheckoutSubmit();
}



/**
 * 18. Appointment Request (Vettel II)
 */

/*
	1. Customer chooses a date
		- Update the slots dropdown to show correct time slots for that day
		- Empty hidden inputs
	2. Customer chooses an appointment slot
		- Update hidden inputs with date and time
*/

//Helper - used to convert dates from eg. "2014-05-28" to a date object - required by IE /
function convertDateTextToObject(dateText, delim) {
	var dateArray = dateText.split(delim);
	var dateObject = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
	return dateObject;
}

//Update the content of the slots dropdown /
function setAppointmentSlots(dateText) {
	//Build date object from calendar output /
	var chosenDate = convertDateTextToObject(dateText, "-");
	//Get slot array for selected day /
	var chosenWeekday = chosenDate.getDay();
	var chosenWeekdaySlots = weekdayStoreSlots[chosenWeekday];
	var chosenHideSlots = hideStoreSlots[dateText];
	//Reset then rebuild the select /
	$('#appointment_slots').empty();
	if (chosenWeekdaySlots.length > 0 && storeClosedOnDate(dateText) == false) {
		$('#appointment_slots').append(
			$("<option></option>")
				.attr("value", 0)
				.text(chooseSlotOptionText)
		);
		for (var i = 0; i < chosenWeekdaySlots.length; i++) {
			if (typeof chosenHideSlots !== 'undefined') {
				var addslot = true;
				for (var j = 0; j < chosenHideSlots.length; j++) {
					if (chosenWeekdaySlots[i] == chosenHideSlots[j]) {
						addslot = false;
					}
				}
				if (addslot) {
					$('#appointment_slots').append(
						$("<option></option>")
							.attr("value", chosenWeekdaySlots[i])
							.text(chosenWeekdaySlots[i])
					);
				}
			} else {
				$('#appointment_slots').append(
					$("<option></option>")
						.attr("value", chosenWeekdaySlots[i])
						.text(chosenWeekdaySlots[i])
				);
			}
		}
	} else {
		$('<option>').val(0).text(closedOptionText).appendTo('#appointment_slots');
	}
	$('#appointment_slots :nth-child(1)').prop('selected', true);
}

// Pass two Date objects, and return the difference in whole days between the two dates - used for GA Event Tracking
function wholeDaysDiff(day1, day2) {
	day1 = day1.setHours(0, 0, 0, 0);
	day2 = day2.setHours(0, 0, 0, 0);
	return Math.round((day1 - day2) / (1000 * 60 * 60 * 24));
}

//Check for closed days /
function storeClosedOnDate(dt) {
	if (storeClosures[dt]) {
		return true;
	}
	return false;
}

function setTimeslotValues() {
	removeTimeslotErrorMessages();
	var selectedTimeSlot = $('#appointment_slots').find(":selected")
	var chosenSlotTime = selectedTimeSlot.val();

	$("#date_1").val(getReplenishDate());
	$("#timeslot_1").val(chosenSlotTime);
}

function clearTimeslotValues() {
	$("#date_1").val("");
	$("#timeslot_1").val("");
}

function removeTimeslotErrorMessages() {
	$(".generic-error").remove();
}

/**
 * 19. Legacy funcs to remove
 */

function submitDoc(formName) {
	var obj = getObById(formName);
	if (obj != null) {
		obj.submit();
	}
}

//Address Book change labels to show what is required and the value of County/State/Province
function changeAddressValidation() {
	var country = getObById('country').value;
	if (country == 'AU') {
		getObById('countyLabel').innerHTML = lang_state + lang_required;
		getObById('postcodeLabel').innerHTML = lang_postcode + lang_required;
		required_address_fields = ["name", "country", "add_1", "town", "postcode", "county"];
	} else if (country == 'CA') {
		getObById('countyLabel').innerHTML = lang_province + lang_required;
		getObById('postcodeLabel').innerHTML = lang_postcode + lang_required;
		required_address_fields = ["name", "country", "add_1", "town", "postcode", "county"];
	} else if (country == 'US') {
		getObById('countyLabel').innerHTML = lang_state + lang_required;
		getObById('postcodeLabel').innerHTML = lang_zipcode + lang_required;
		required_address_fields = ["name", "country", "add_1", "town", "postcode", "county"];
	} else if (country == 'IE') {
		getObById('countyLabel').innerHTML = lang_county;
		getObById('postcodeLabel').innerHTML = lang_postcode;
		required_address_fields = ["name", "country", "add_1", "town"];
	} else if (country == 'GB') {
		getObById('countyLabel').innerHTML = lang_county;
		getObById('postcodeLabel').innerHTML = lang_postcode + lang_required;
		required_address_fields = ["name", "country", "add_1", "town", "postcode"];
	} else {
		getObById('countyLabel').innerHTML = lang_county;
		getObById('postcodeLabel').innerHTML = lang_postcode + lang_required;
		required_address_fields = ["name", "country", "add_1", "town", "postcode"];
	}

	// Packstation Address Fields Validation
	if ($("#packstation").length) {
		required_address_fields.push("add_2");
		var packstation_radio = $('input[name=packstationRadio]:checked').val();
		if (packstation_radio > 0) {
			$("#postcodeLabel").html(lang_packstation_postcode_town + lang_required);
			required_address_fields.push("company");
		} else {
			$("#postcodeLabel").html(lang_postcode_town + lang_required);
		}
		required_address_fields.splice(required_address_fields.indexOf("county"), 1);
	}
}

function disableECOButtons() {
	if (typeof (disableButtons) != 'undefined' && disableButtons) {
		iterateThroughButtonsAndDisable(disableButtons);
	}
}
function enableECOButtons() {
	if (typeof (disableButtons) != 'undefined' && disableButtons) {
		iterateThroughButtonsAndEnable(disableButtons);
	}
}

function hideECOButtons() {
	if (typeof (allow_hideECOButtons) != 'undefined' && allow_hideECOButtons) {
		if (typeof (disableButtons) != 'undefined' && disableButtons) {
			for (i = 0; i < disableButtons.length; i++) {
				$("#" + disableButtons[i]["button"]).hide();
			}
		}
	}
}

function showECOButtons() {
	if (typeof (disableButtons) != 'undefined' && disableButtons) {
		for (i = 0; i < disableButtons.length; i++) {
			$("#" + disableButtons[i]["button"]).show();
		}
	}
}

function sendProcessorInformation() {
	var $paymentOption = $('input[name="paymentOption"]:checked');
	var $label = $("label[for='" + $paymentOption.closest('tr').find('.showOnlyWhenSelected > input').attr("id") + "']");

	return updateProcessorLog($label.data('name'), $label.data("data"), $label.data('hash'));
}

function sendTrustedShopConsent() {
	var $consentChecked = $('input[name="termsTrustedShops"]:checked');
	var $label = $("label[for='" + $consentChecked.attr("id") + "']");
	if ($consentChecked.length !== 0) {
		GA_Event_Trigger("Checkout", "Opt In", "Trusted Shops");
	}
	return updateProcessorLog($label.data('name'), $label.data("data"), $label.data('hash'));
}

function showCheckoutModal() {
	var message_parts = checkoutModalMessaging();
	$("#checkoutModal").dialog({
		title: message_parts[0],
		width: 500,
		modal: true,
		closeOnEscape: false,
		open: function (event, ui) { $(".ui-dialog-titlebar-close").hide(); }
	});
	$("#checkoutModalMessage").html(message_parts[1]);
	showRetryLink = setTimeout(function () {
		$('#modalRetryLink').show();
	}, 30000);
}

function hideCheckoutModal() {
	try {
		$('#checkoutModal').dialog('close');
	} catch(e) {
		// Nothing to do
	}

	if (typeof showRetryLink !== 'undefined') {
		clearTimeout(showRetryLink);
	}
}

// German version of setupPaymentMethods above. TODO: combine these and move checkSelected arguments into setupPaymentMethods params.
function setupPaymentMethodsHighlighting(inputName, inputContainer, containerClassName) {
	$(document).ready(function () {
		$("#paymentOptions").on('click', 'input[name=' + inputName + ']', function () {
			checkSelected(inputName, inputContainer, containerClassName);
		});
		checkSelected(inputName, inputContainer, containerClassName);
	});
}

function setupAddressesLangSwap(langOb) {
	if (typeof langOb !== 'undefined') {
		$(document).ready(function () {
			$("input[name=" + langOb['inputName'] + "]").on("click", function () {
				updateLabelText(langOb);
			});
			updateLabelText(langOb);
		});
	}
}

/* Position an element centrally, both vertically and horizontally, within its parent.
 * Element explicitly needs a width in some cases, as setting position to absolute will remove an auto width.
 */
function centerWidthAndHeight(elId) {
	var $cWHContent = $("#" + elId);
	var wid = $cWHContent.width();
	var hei = $cWHContent.height();
	$cWHContent.css({
		"position": "absolute",
		"left": "50%",
		"top": "50%",
		"margin-left": - wid / 2,
		"margin-top": - hei / 2
	});
}

function centerHeight(elId) {
	var $cHContent = $("#" + elId);
	var hei = $cWHContent.height();
	$cWHContent.css({
		"margin-left": - wid / 2,
		"margin-top": - hei / 2
	});
}

// LisaKelly:
function showBillingAddressFrame() {
	$('#reorderBillingAddress').show();
	$('#addresses').slideDown();
	$('#addAddress').hide();
	$('#changeBillingLink').hide();
	setMatchingBoxHeights("js-address-box", true);
	if (typeof (showCurrentlySelectedTextOnOpening) !== "undefined" && showCurrentlySelectedTextOnOpening) {
		$(".js-address-currently-selected").show();
	}
}

function changeFilter() {
	var filter = $('#brandFilter').val();
	if (filter == '') {
		document.location.href = document.location.href.split('?')[0];
	} else {
		document.location.href = document.location.href.split('?')[0] + '?brandFilter=' + options[filter];
	}
}

//Nick Mather - Mobile Switcher
function mobileSwitcher(mode) {
	GA_Event_Trigger("Footer", "click", "View on Mobile");
	$.ajax({
		url: rootURLProt + "?_g=ex&type=mobileSwitcher&mode=" + mode + "&rand=" + Math.random(),
		type: 'GET',
		async: true
	}).done(function (msg) {
		if (msg == 'OK') {
			document.location.href = document.location.href;
		} else {
			return false;
		}
	});
}

//Asafisk - Google Analytics Event Trigger
function GA_Event_Trigger(g_cat, g_act, g_lab, g_val) {
	// Duplicate events in GA 360
	var eventParameters = {
		event_category: g_cat,
		event_label: g_lab
	}
	if (typeof g_val !== "undefined") {
		eventParameters.value = g_val;
	}
	gtag_event_trigger(g_act, eventParameters);

	if (typeof ga !== 'undefined') {
		if (typeof g_val !== "undefined") {
			ga('send', 'event', g_cat, g_act, g_lab, g_val, { 'nonInteraction': 1 });
		} else {
			ga('send', 'event', g_cat, g_act, g_lab, { 'nonInteraction': 1 });
		}

		return false;
	}

	var i = 1;
	var interval = setInterval(function () {
		if (typeof window.ga !== 'undefined') {
			if (typeof g_val !== "undefined") {
				ga('send', 'event', g_cat, g_act, g_lab, g_val, { 'nonInteraction': 1 });
			} else {
				ga('send', 'event', g_cat, g_act, g_lab, { 'nonInteraction': 1 });
			}

			clearInterval(interval);
		}

		// Failsafe interval loop
		if (i >= 10) {
			clearInterval(interval);
		}

		i++;
	}, 500);
}

function gtag_event_trigger(gtag_action, gtag_params) {
	if (typeof window.gtag !== 'undefined' && typeof window.event_send_to !== 'undefined' && window.event_send_to !== '') {
		gtag_params = gtag_params || {};
		gtag_params.send_to = window.event_send_to;
		gtag('event', gtag_action, gtag_params);
	}
}

/* Send an Event to Split.io */
/*
 * @param string trafficType
 * @param string eventType
 * @param int value (optional)
 * @param object properties (optional)
 * 
 * Returns true if event successfully queued to be sent back to Split's servers on the next event post
 * Else returns false
 */
function splitEventTrigger(trafficType, eventType, value, properties) {
	value = value || null;
	properties = properties || {};
	if (typeof window.splitClient !== 'undefined') {
		return window.splitClient.track(trafficType, eventType, value, properties);
	}
	return false;
}

// Search bar autocomplete - openInputClass is an optional argument - a string which is added as a class to the search input
function createSearchAutocomplete(searchId, queryString, minChars, openInputClass) {
	var displayEventFired = false;
	var autoSearchUrl = rootURLProt + queryString;
	$(document).ready(function () {
		var $searchForm = $('#' + searchId);
		var autocompleteList;

		$searchForm.autocomplete({
			delay: 50,
			open: function (event, ui) {
				var self = this;

				if (typeof openInputClass != 'undefined') {
					$searchForm.addClass(openInputClass);
				}

				if ($('.js-autocomplete-input').length) {
					// Adjust autocomplete list on various screens
					var inputWidth = $(self).outerWidth();

					// Match the input width with the autocomplete list
					$(self).css({
						width: inputWidth
					});

					// Match the autocomplete list with the input width
					autocompleteList.css({
						width: inputWidth
					});
				}

				$(window).on("resize orientationchange", function () {
					$(self).autocomplete("close");
				});
			},
			close: function (event, ui) {

				if (typeof openInputClass != 'undefined') {
					$searchForm.removeClass(openInputClass);
				}
				$(this).removeAttr('style');
			},
			source: function (request, response) {
				// Overwrite autocomplete's default use of "term" as the search term param - this appends "searchLetters={searchterm}" to the source URL
				$.getJSON(autoSearchUrl, { searchLetters: request.term }, response);
			},
			minLength: minChars,
			select: function (event, ui) {
				MarketingEvents.trigger('Search', ui.item.value, 'select');

				if (typeof ga != 'undefined') {
					GA_Event_Trigger('Search Auto-Complete', 'click - ' + ui.item.href, ui.item.searchterm);
				}

				location.href = rootURL + ui.item.href;
			},
			response: function (event, ui) {
				if (ui.content.length > 0) {
					// Fire a one-time tracking event on first display of search results.
					if ((typeof ga != 'undefined') && !(displayEventFired)) {
						GA_Event_Trigger('Search Auto-Complete', 'ResultsDisplayed');
						displayEventFired = true;
					}
					var searchTerm = ui.content[0]['searchterm'];
					var re = new RegExp(searchTerm, "gi");
					// Wrap <strong> tags around the content which matches the search term.
					for (var i = 0, arrayL = ui.content.length; i < arrayL; i++) {
						ui.content[i]['label'] = ui.content[i]['label'].replace(re, function (str) { return '<strong class="c-autocomplete-list_matching-text">' + str + '</strong>' });
					}
				}
			}
		}).data("ui-autocomplete")._renderItem = function (ul, item) {
			ul.addClass("autoSearchResultList c-autocomplete-list");
			ul.data("original-input", searchId);

			// Cache the autocomplete list element
			autocompleteList = ul;

			var autoSearchDuration = '';

			if (item.duration) {
				autoSearchDuration = '&nbsp;<span class="autoSearchDuration c-autocomplete-list__duration">' + item.duration + '</span>';
			}

			return $("<li></li>")
				.attr("class", "autoSearchResultItem c-autocomplete-list__item")
				.data("item.autocomplete", item)
				.append('<a class="c-autocomplete-list__link" href="' + rootURL + item.href + '">' + item.label + autoSearchDuration + '</a>')
				.appendTo(ul);
		};
	});
}

//Enhanced ecommerce pre-checkout tracking
function gaOnProductClick(productId, productCode, productName, cat, brand, pos, listName, variant) {
	if (typeof ga != 'undefined') {
		ga('ec:addProduct', {
			'id': '' + productCode + '',
			'name': '' + productName + '',
			'category': '' + cat + '',
			'brand': '' + brand + '',
			'variant': '' + variant + '',
			'position': pos
		});

		ga('ec:setAction', 'click', { list: listName.toString() });

		// Send to GA 360
		var listClickParameters = {
			event_category: 'List',
			event_label: listName.toString()
		}
		gtag_event_trigger('click', listClickParameters);

		// Send click with an event, then send user to product page.
		ga('send', 'event', 'List', 'click', listName.toString(), {
			hitCallback: function () {
				return true;
			}
		});
	}
	return true;
}

function gaForAddToBasket(productCode, productName, price, sendClickEvent, productCat, productBrand) {
	if (typeof ga != 'undefined') {
		ga('ec:addProduct', {
			'id': '' + productCode + '',
			'name': '' + productName + '',
			'price': '' + price + '',
			'category': '' + productCat + '',
			'brand': '' + productBrand + ''
		});
		ga('ec:setAction', 'add');
		// Send click with an event
		if (sendClickEvent) {
			GA_Event_Trigger('Product', 'click', 'add to cart');
		}
	}
}

function gaRemoveFromCart(productCode, productName, price, productTypeName, productCat, productBrand) {
	if (typeof ga != 'undefined') {
		ga('ec:addProduct', {
			'id': '' + productCode + '',
			'name': '' + productName + '',
			'price': '' + price + '',
			'category': '' + productCat + '',
			'brand': '' + productBrand + ''
		});
		ga('ec:setAction', 'remove');
		// Send click with an event
		GA_Event_Trigger('Basket', 'click', 'remove from cart - ' + productTypeName);
	}
}

// Called in global templates. Find all elements with a class of trackingClass (typically "gaTrackedClick"), and bind an event handler to the element's click event. This handler sends some of the link's data attributes to GA.
function initialiseGAClicks(trackingClass) {
	$(document).ready(function () {
		var $gaLinks = $("." + trackingClass);
		$gaLinks.on("click", function (event) {
			GA_Event_Trigger($(this).data("gacategory"), "click", $(this).data("galabel"));
		});
	});
}

/**
 * Grand Vision add to Basket information
 * @param form
 */
function gvUpdateBasketFromFormData(form) {
	var units = 1;
	var unitsObject = $('input[name=units]:checked', form);

	// if the unit's value is higher or equal to 1 then use it, else we should just use 1.
	if (unitsObject.val() >= 1) {
		units = unitsObject.val();
	}
	var qty = 1;

	// If there's a quan, we are in the product page.
	var $qtyBox = $("#quan")
	if ($qtyBox.length) {
		qty = $qtyBox.val();
		// If we have an original quantity, we're changing prescription. We want to capture the change in basket quantity.
		if ($qtyBox.data("origquantity")) {
			var difference = qty - $qtyBox.data("origquantity");
		}
	}

	var id = $(form).data('gvproductid');
	if (id !== undefined && id.length > 0) {
		if (typeof (difference) != "undefined") {
			if (difference > 0) {
				// Adding to basket
				gvFireAddToShoppingCartAction(id, difference);
			} else if (difference < 0) {
				// Removing from basket
				gvFireRemoveFromShoppingCartAction(id, Math.abs(difference));
			}
		} else {
			// add the main product to the basket.
			gvFireAddToShoppingCartAction(id, qty * units);
		}
	}
}

function gvFireAddToShoppingCartAction(id, quantity) {
	gvFireShoppingCartAction(id, quantity, 'add_to_cart');
}

function gvFireRemoveFromShoppingCartAction(id, quantity) {
	gvFireShoppingCartAction(id, quantity, 'remove_from_cart');
}

function gvFireShoppingCartAction(id, quantity, name) {
	if (name == "remove_from_cart") {
		var type = "DeleteAction";
	} else if (name == "add_to_cart") {
		var type = "AddAction";
	}
	var orderAction = {
		"@context": "https://schema.org",
		"@type": type,
		"name": name,
		"object": {
			"@type": "Product",
			"@id": id,
			"offers": {
				"@type": "Offer",
				"includesObject": {
					"@type": "TypeAndQuantityNode",
					"amountOfThisGood": quantity
				}
			}
		}
	};
	pushGrandVisionActions(orderAction);
}

function cartChangeQuantity(elem) {
	var element = $(elem);
	var container = element.closest('.js-basket-table-row');

	var difference = element.val() - container.data('origquantity');
	var id = container.data('gvproductid');
	if (difference > 0) {
		gvFireAddToShoppingCartAction(id, difference);
	} else {
		gvFireRemoveFromShoppingCartAction(id, Math.abs(difference));
	}

	submitDoc('cart');
}

function gvRefillCart(products) {
	$.each(products, function (key, value) {
		if (value > 0) {
			gvFireAddToShoppingCartAction(key, value);
		} else {
			gvFireRemoveFromShoppingCartAction(key, Math.abs(value));
		}
	});
}

function CartDeleteEntry(elem, productCode, productName, price, productTypeName, productCat, productBrand) {
	var container = $(elem).closest('.js-basket-table-row');
	gvFireRemoveFromShoppingCartAction(container.data('gvproductid'), container.data('origquantity'));
	gaRemoveFromCart(productCode, productName, price, productTypeName, productCat, productBrand);
}


function trackCommunicationPrefs() {
	$(document).ready(function () {
		$(".optincheckbox input[type=radio], .js-optin-checkbox input[type=radio]").on("click", function () {
			var commAction = $(this).val() == 1 ? "Subscribed" : "Unsubscribed";
			GA_Event_Trigger("Communication Preferences", commAction, $(this).data("commtype"));
		});
	});
}

function homeTabsSetup() {
	$(document).ready(function () {
		$(".homeTab").on("click", function (e) {
			e.preventDefault();
			$(".homeTab").removeClass("homeTabSelected");
			$(this).addClass("homeTabSelected");
			$(".homeTabContent").hide();
			$("#" + $(this).data("tabcontent")).show();
		});
	});
}

function goToSelectLinkVal(selectBox) {
	var linkval = $(selectBox).find("option:selected").data("linkval");
	window.location = linkval;
}

// Force reload of page on clicking back. Prevents issue with cached DOM updates displaying old element states
function setupReloadOnCacheLoad() {
	$(window).on("pageshow", function (event) {
		if (event.originalEvent.persisted) {
			window.location.reload();
		}
	});
}

// Send a GA event when checking / unchecking a checkbox
function trackCheckboxChecked(checkbox, g_cat, g_label, addMessage) {
	var checkedVal = (checkbox.checked) ? "Checked" : "Unchecked";
	if (typeof (addMessage) != 'undefined') {
		checkedVal += addMessage;
	}
	GA_Event_Trigger(g_cat, checkedVal, g_label);
}

/* Sunglasses splash page code */
/*
 * Highlight every cell in a column
 */
function highlightCol(hoveredCell) {
	var indexOfCell = $(hoveredCell).index();
	$(".sunglassesShapes tr").each(function () {
		$(this).find("td").eq(indexOfCell).addClass("hovered");
	});
}
/*
 * Add event listener to each table cell except the first in a row.
	*/
function setupColumnHighlighting(tableClass) {
	$(document).ready(function () {
		$("." + tableClass + " td:not(:first-child)").on(
			{
				"mouseover": function () {
					highlightCol(this);
				},
				"mouseout": function () {
					$("." + tableClass + " td").removeClass("hovered");
				}
			}
		);
	});
}



/* Email address autosuggest
 *
 * values in the configVals object are as follows:
 *
 * array addressOptions: array of domain names e.g. gmail.com
 * int characterLimit: max number of characters to display before the @ symbol
 * string inputId: ID of the input to receive autosuggests
 * string listClass: class added to Autocomplete UL
 * string listItemClass: class added to individual list items
 */
function autosuggestEmailAddress(configVals) {

	if (typeof configVals.inputId === 'undefined' || $.trim(configVals.inputId) === '') {
		return false;
	}

	var $input = $('#' + configVals.inputId);
	var autocompleteList;

	// Initialise the autocomplete widget.
	$input.autocomplete({
		source: configVals.addressOptions,
		open: function (event, ui) {
			var self = this;

			// Adjust autocomplete list on various screens
			var inputWidth = $(self).outerWidth();

			// Match the input width with the autocomplete list
			$(self).css({
				width: inputWidth
			});

			var autocompleteStyle = {
				width: inputWidth
			};

			var $container;
			var containerIdentifiers = [
				// Lenstore UK / EU
				'#Wrapper',
				// Lenstore DE
				'.o-outer',
				// NextDayLenses
				'.container'
			];

			$.each(containerIdentifiers, function (index, identifier) {
				var $element = $(identifier);

				if ($element.length) {
					$container = $element.eq(0);

					return false;
				}
			});

			if (typeof $container !== 'undefined' && $container.length) {
				// Get the dimensions of page elements
				var windowWidth = $(window).width();
				var wrapperWidth = $container.outerWidth();

				// Calculate the wrapper margin from screen edge
				var wrapperMargin = (windowWidth - wrapperWidth) / 2;

				// Adjust autocomplete list position
				if (wrapperMargin > 0) {
					var inputOffset = $(self).offset();

					autocompleteStyle.left = inputOffset.left;
				}
			}

			// Match the autocomplete list with the input width and position
			autocompleteList.css(autocompleteStyle);

			$(window).on("resize orientationchange", function () {
				$(self).autocomplete("close");
			});
		},
		close: function (event, ui) {
			$(this).removeAttr('style');
		},
		select: function (event, ui) {
			GA_Event_Trigger(configVals.pageIdentifier, "click", "");
		}
	}).data("ui-autocomplete")._renderItem = function (ul, item) { // Override the Autocomplete default item rendering.
		// Create the content that's placed in the suggestion box. We use shortenedAddress, rather than the original label.
		ul.addClass(configVals.listClass);

		// Cache the autocomplete list element
		autocompleteList = ul;

		return $("<li></li>")
			.attr("class", configVals.listItemClass)
			.data("item.autocomplete", item)
			.append('<a class="' + configVals.listItemLinkClass + '">' + item.shortenedAddress + '</a>')
			.appendTo(ul);
	};

	$input.one("autocompleteopen", function (event, ui) {
		GA_Event_Trigger(configVals.pageIdentifier, "Open", "");
	});

	// Fire when any content is entered into the input of ID inputId
	$input.on("input", function () {
		// Do nothing unless there's an @ symbol in the form.
		if ($(this).val().indexOf('@') != -1) {
			$(this).autocomplete("enable");
			// Create an updated list of matchable options
			var new_options = [];
			// Only use the substring prior to an @ symbol.
			var str = $(this).val().split('@')[0];
			var truncatedString = truncateString(str, configVals.characterLimit);
			// Update the matching options with the input and @ symbol prepended
			for (var i = 0; i < configVals.addressOptions.length; i++) {
				new_options[i] = { value: str + '@' + configVals.addressOptions[i], shortenedAddress: truncatedString + "@" + configVals.addressOptions[i] };
			}
			// Update the source option of the already-created autocomplete widget.
			$(this).autocomplete("option", "source", new_options);
			// Run a search within the new source options
			$(this).autocomplete("search", $(this).val());
		} else {
			$(this).autocomplete("disable");
		}
	});
}

// Cut down a string to a certain length, and append something to the end (default ellipsis) if the string has been cut.
function truncateString(str, characterLimit, appended) {
	appended = appended || '&hellip;';
	if (str.length > characterLimit) {
		str = str.substring(0, characterLimit) + appended;
	}
	return str;
}


/*
 * Lazy load background images
 */

// Setup for loading background images within the viewport.
function lazyLoadBackgroundImage(lazyLoadClassname) {
	// Check whether elements are already above the fold. If so, load now.
	$("." + lazyLoadClassname).each(function (index) {
		checkElementForLazyLoad(this);
	});
	// Check for now-onscreen images when we scroll
	$(window).on("scroll.lazyLoadingBg", function () {
		// Iterate through each "."+lazyLoadClassname that doesn't already have the lazyLoaded class
		// If the element is above the fold, lazyload it.
		var $notYetLoaded = $("." + lazyLoadClassname).not(".lazyLoadedBg");
		$notYetLoaded.each(function () {
			checkElementForLazyLoad(this);
		});
		// Stop listening for a scroll if there are no lazyload background images left to load.
		if ($notYetLoaded.length == 0) {
			$(window).off("scroll.lazyLoadingBg");
		}
	});
}

// If element is visible in viewport, load its background image
function checkElementForLazyLoad(element) {
	if (isVisibleInViewport(element)) {
		loadBgImage(element);
	}
}

// Return whether an element is visible within the viewport
function isVisibleInViewport(element) {
	var $element = $(element);
	var $window = $(window);
	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();
	var elemTop = $element.offset().top;
	var elemBottom = elemTop + $element.height();
	// Is the top of the element above the bottom of the doc, and is the bottom of the element below the top of the doc?
	return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}

// Get an element's background image dataval, and load it. Add an additional class so we don't try loading it again.
function loadBgImage(element) {
	var bgVal = $(element).data("backgroundImage");
	if (bgVal) {
		$(element).css({ "background-image": "url(" + rootURLProt + bgVal + ")" });
	}
	// Set element as loaded. No point retrying, so do so regardless of whether the background image data val has been set.
	$(element).addClass("lazyLoadedBg");
}

/*
 * 20. Bastian
 */

//Address Book change labels for Packstations
function changeAddressFields() {
	if ($("#packstation").length) {
		var name_value = $("#name").val();
		var company_value = $("#company").val();
		var packstation_radio = $('input[name=packstationRadio]:checked', '.packstationAddressSwitch').val();
		if (packstation_radio > 0) {
			// Use Company Field for Name
			$("#company").val(name_value);
			$("#company").attr("placeholder", $("#name").attr("placeholder"));
			$("#companyLabel").html(lang_name + lang_required);
			// Use Name Field for Post Number
			$("#name").val(company_value);
			$("#name").attr("placeholder", lang_post_number_placeholder);
			$("#nameLabel").html(lang_post_number + lang_required);
			// Use Add2 for Packstation Number
			$("#add2Label").html(lang_packstation_number + lang_required);
			$("#add_2").attr("placeholder", lang_packstation_number_placeholder);
			// Hide Add 1 and hardcode to Packstation
			if ($("#add_1").val() != "Packstation") {
				$("#add_1").attr("add_1", $("#add_1").val());
			}
			$("#add_1").val("Packstation");
			$("#add_1").hide();
			$("#postcodeLabel").html(lang_packstation_postcode_town + lang_required);
			$("#town").attr("placeholder", lang_packstation_town_placeholder);
			$("#packstation").val(1);
			$("#findPackstation").show();
		} else {
			// Put Fields Back
			$("#name").val(company_value);
			$("#name").attr("placeholder", $("#company").attr("placeholder"));
			$("#company").val(name_value);
			$("#company").removeAttr("placeholder");
			$("#nameLabel").html(lang_name + lang_required);
			$("#companyLabel").html(lang_company);
			$("#add2Label").html(lang_street_add_2 + lang_required);
			$("#add_2").attr("placeholder", lang_add2);
			if ($("#add_1").attr("add_1")) {
				$("#add_1").val($("#add_1").attr("add_1"));
			} else {
				$("#add_1").val("");
			}
			$("#add_1").show();
			$("#postcodeLabel").html(lang_postcode_town + lang_required);
			$("#town").attr("placeholder", lang_town);
			$("#packstation").val(0);
			$("#findPackstation").hide();
		}
		changeAddressValidation();
	}
}

function GA_MP_trigger(clientId, orderId) {
	var xmlHttp = getXMLHttp();
	xmlHttp.open("GET", rootURLProt + "?_g=ex&type=gamp&clientid=" + clientId + "&orderid=" + orderId + "&rand=" + Math.random(), true);
	xmlHttp.send(null);
}

/* Cookies Bar close function */
function setupCookiesBarCloser(containerId, closerId) {
	$('#' + closerId).on('click', function (e) {
		e.preventDefault();

		var $container = $('#' + containerId);

		$container.fadeOut(300, function () {
			$container.remove();
		});
	})
}

/* Consent Renewal */

function sendConsent(elId, siteroot, consentArray, consentVal, consentTypes, promptMode) {
	applyWaitingOverlay(elId);
	var widgetHTML = '';
	var parameters = "&consenttext=" + encodeURIComponent(JSON.stringify(consentArray)) + "&consentval=" + consentVal + "&consent_types=" + consentTypes + "&promptmode=" + promptMode;
	var xmlHttp = getXMLHttp();
	xmlHttp.onreadystatechange = function () {
		if (xmlHttp.readyState == 4) {
			$("#" + elId).remove();
			removeTriggerOnNotificationClose = true;
			if (xmlHttp.responseText != "") {
				$(".notification-block-arrow").addClass("notification-block-arrow--success");
				$("#consentRenewalAcknowledgement").show();
				$(".js-for-initial-display").hide();
			} else {
				$(".notification-block-arrow").addClass("notification-block-arrow--error");
				$("#consentRenewalError").show();
				$(".js-for-initial-display").hide();
				if (typeof (consentDisplayType) != "undefined" && consentDisplayType == "banner") {
					if (promptMode == 1) {
						GA_Event_Trigger('Consent Renewal', 'Opt in Error', '');
					} else {
						GA_Event_Trigger('Communications opt in', 'Opt in Error', '');
					}
				}
				if (typeof (consentDisplayType) != "undefined" && consentDisplayType == "notification") {
					if (promptMode == 1) {
						GA_Event_Trigger('Consent Renewal Notification', 'Opt in Error', '');
					} else {
						GA_Event_Trigger('Communications opt in Notification', 'Opt in Error', '');
					}
				}
			}
		}
	}
	xmlHttp.open("POST", siteroot + "?_g=ex&_a=consentrenewal&rand=" + Math.random(), true);
	xmlHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	xmlHttp.send(parameters);
	if (typeof (consentDisplayType) != "undefined" && consentDisplayType == "banner") {
		if (promptMode == 1) {
			GA_Event_Trigger('Consent Renewal', 'Opt in', '');
		} else {
			GA_Event_Trigger('Communications opt in', 'Opt in', '');
		}
	}
	if (typeof (consentDisplayType) != "undefined" && consentDisplayType == "notification") {
		if (promptMode == 1) {
			GA_Event_Trigger('Consent Renewal Notification', 'Opt in', '');
		} else {
			GA_Event_Trigger('Communications opt in Notification', 'Opt in', '');
		}
	}
	return false;
}

function logConsentDismiss(siteroot) {
	var xmlHttp = getXMLHttp();
	xmlHttp.open("GET", siteroot + "/?_g=ex&_a=optindismiss&rand=" + Math.random(), true);
	xmlHttp.send(null);
}

function setupConsentClosers(siteroot, promptMode) {
	$(document).ready(function () {
		$(".js-consent-closer").on("click", function (e) {
			e.preventDefault();
			logConsentDismiss(siteroot);
			$(this).closest(".js-consent-container").slideUp("fast", function () {
				$(this).remove();
				if (promptMode == 1) {
					GA_Event_Trigger('Consent Renewal', 'Close', '');
				} else {
					GA_Event_Trigger('Communications opt in', 'Close', '');
				}
			});
		})
	});
}

/* Move consent content into the appropriate block, defined by containerId */
function fillInConsentRenewal(containerId) {
	$(document).ready(function () {
		if ($("#consentRawContent").length && ((typeof qualify1 != "undefined" && qualify1) || (typeof qualify2 != "undefined" && qualify2))) {

			var $selectedContainer = $("#" + containerId);
			$selectedContainer.find(".js-consent-title").replaceWith($("#consentTitle"));
			$selectedContainer.find(".js-consent-line-1").replaceWith($("#consentLine1"));
			$selectedContainer.find(".js-consent-line-2").replaceWith($("#consentLine2"));
			$selectedContainer.find(".js-consent-line-3").replaceWith($("#consentLine3"));
			$selectedContainer.find(".js-consent-submit").replaceWith($("#consentSubmit"));

			$selectedContainer.find(".js-consent-response-title").replaceWith($("#consentRenewalTitle"));
			$selectedContainer.find(".js-consent-response-line-1").replaceWith($("#consentRenewalLine1"));
			$selectedContainer.find(".js-consent-response-line-2").replaceWith($("#consentRenewalLine2"));
			$selectedContainer.find(".js-consent-response-line-3").replaceWith($("#consentRenewalLine3"));

			$selectedContainer.find(".js-consent-error-title").replaceWith($("#consentErrorTitle"));
			$selectedContainer.find(".js-consent-error-line-1").replaceWith($("#consentErrorLine1"));

			$selectedContainer.find(".js-for-initial-display").attr("id", "consentRenewal");
			$selectedContainer.find(".js-consent-acknowledgement-box").attr("id", "consentRenewalAcknowledgement");
			$selectedContainer.find(".js-consent-error-box").attr("id", "consentRenewalError");

			switch (containerId) {
				case "consentRenewalContainer":
					if (typeof (consentDisplayType) != "undefined") {
						consentDisplayType = "banner";
					}
					$("#ConsentComPrefLink").on("click", function () {
						GA_Event_Trigger('Consent Renewal', 'click', 'Comms Pref');
					});
					if (configShow && !seenOften) {
						$selectedContainer.show();
						$selectedContainer.find(".js-for-initial-display").show();
						if (typeof (qualify1) != "undefined" && qualify1) {
							GA_Event_Trigger('Consent Renewal', 'Impression', '');
						}
						if (typeof (qualify2) != "undefined" && qualify2) {
							GA_Event_Trigger('Communications opt in', 'Impression', '');
						}
					}
					break;
				case "notificationBlockContainer":
					if (typeof (consentDisplayType) != "undefined") {
						consentDisplayType = "notification";
					}
					$("#notificationTrigger").show();
					$selectedContainer.find(".js-for-initial-display").show();
					if (typeof (increaseShoppingCartWidth) != "undefined" && increaseShoppingCartWidth) {
						$("#shoppingCartContainer").css("width", "+=" + increaseShoppingCartWidth);
						$("#shoppingCart").css("width", "+=" + increaseShoppingCartWidth);
						$("#talkToOptician").css("right", "+=" + increaseShoppingCartWidth);
					}
					$("#ConsentComPrefLink").on("click", function () {
						GA_Event_Trigger('Consent Renewal Notification', 'click', 'Comms Pref');
					});
					if (typeof (showNotificationOnPageLoad) !== "undefined" && showNotificationOnPageLoad) {
						GA_Event_Trigger('Consent Renewal Notification', 'Open', 'Open by default');
						if (typeof (openedByDefault) !== "undefined") {
							openedByDefault = true;
						}
						$("#notificationTrigger").trigger("click");
					}
					if (typeof (qualify1) != "undefined" && qualify1) {
						GA_Event_Trigger('Consent Renewal Notification', 'Impression', '');
					}
					if (typeof (qualify2) != "undefined" && qualify2) {
						GA_Event_Trigger('Communications opt in Notification', 'Impression', '');
					}
					break;
			}
		}
	});
}


/* Notifications */
/*
 * @param string trigger   - ID of the element which, when clicked, opens the notification block
 * @param string block     - ID of the notifications block element
 * @param wrapper block    - ID of the element to which the notification block is appended on open
 * @param string arrow     - ID of the triangle element - repositioned horizontally relative to the trigger element
 * @param string openClass - classname applied to the notification block to mark it as open
 * @param string closer    - ID of the closer element - closes block if open
 *
 * Param values are set in one place (template) and passed as required. Easier portability across different skins.
 *
 * Clicking the trigger element opens / closes the notification block
 * Resizing / changing page orientation calls showNotificationBlock() again if the block is open. This does the repositioning required
 *
 */
function setupNotificationBlock(trigger, block, wrapper, arrow, openClass, closer) {
	$(document).ready(function () {
		$("#" + trigger).on("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			toggleNotificationBlock(trigger, block, wrapper, arrow, openClass);
		})
		$("." + closer).on("click", function (e) {
			if (notificationBlockIsOpen(block, openClass)) {
				closeNotificationBlock(trigger, block, openClass);
			}
		})
		/*
		Commented out for non-fluid desktop skin.
		$(window).on("orientationchange.ls-notifications, resize.ls-notifications", function(){
			if(notificationBlockIsOpen(block, openClass)) {
				showNotificationBlock(trigger, block, wrapper, arrow, openClass);
			}
		});
		*/
	});
}

/* Called when trigger is clicked - should we show / hide the notification block? */
function toggleNotificationBlock(trigger, block, wrapper, arrow, openClass) {
	if (notificationBlockIsOpen(block, openClass)) {
		GA_Event_Trigger('Consent Renewal Notification', 'Close', '');
		closeNotificationBlock(trigger, block, openClass);
	} else {
		if (typeof (openedByDefault) != "undefined" && !openedByDefault) {
			GA_Event_Trigger('Consent Renewal Notification', 'Open', '');
			openedByDefault = false;
		}
		showNotificationBlock(trigger, block, wrapper, arrow, openClass);
	}
}

/* Is the notification block open or closed? */
function notificationBlockIsOpen(block, openClass) {
	return $("#" + block).hasClass(openClass);
}

/* Does the work of opening and positioning the notification block. Notification block needs to be visible for offset to calculate correctly */
function showNotificationBlock(trigger, block, wrapper, arrow, openClass) {
	var $notificationTrigger = $("#" + trigger);
	var $notificationBlock = $("#" + block);
	var triggerOffset = $notificationTrigger.offset();
	var triggerHeight = $notificationTrigger.outerHeight(true);

	$notificationBlock
		.appendTo("#" + wrapper)
		.show()
		.offset({ top: triggerOffset.top + triggerHeight + 10 })
		.addClass(openClass);

	positionNotificationArrow(trigger, arrow);
	setupNotificationClose(trigger, block, openClass);
}

/* Position the notification block arrow horizontally relative to the trigger element */
function positionNotificationArrow(trigger, arrow) {
	var $notificationTrigger = $("#" + trigger);
	var triggerOffset = $notificationTrigger.offset();
	var $arrow = $("#" + arrow);
	$arrow.offset({ left: triggerOffset.left })
}

/* Switch to active state - add listeners associated with handling block closing */
function setupNotificationClose(trigger, block, openClass) {
	$("body").on("click.ls-notifications", function (e) {
		if (!$(e.target).closest("#" + block).length) {
			closeNotificationBlock(trigger, block, openClass);
		}
	});
}

/* Return to base state - close block */
function closeNotificationBlock(trigger, block, openClass) {
	$("#" + block).fadeOut().removeClass(openClass);
	removeNotificationClose();
	if (typeof removeTriggerOnNotificationClose != "undefined" && removeTriggerOnNotificationClose) {
		$("#" + trigger).fadeOut("slow", function () {
			$(this).remove();
		});
	}
}

/* Return to base state - remove listeners associated with handling block closing */
function removeNotificationClose() {
	$("body").off("click.ls-notifications");
}

/* 22. GrandVision Measurement Protocol */

function getGrandVisionOb() {
	return grandvision = window.grandvision || (window.grandvision = {});
}

function getGrandVisionActions() {
	var gvob = getGrandVisionOb();
	return gvob.actions || (gvob.actions = []);
}

function pushGrandVisionActions(jsonObject) {
	var gvactions = getGrandVisionActions();
	gvactions.push(jsonObject);
}

function getGrandVisionUser() {
	var gvob = getGrandVisionOb();
	return gvob.user || (gvob.user = []);
}

function gvOrderStartAction() {
	var orderAction = {
		"@context": "https://schema.org",
		"type": "Action",
		"name": "order_start"
	};
	pushGrandVisionActions(orderAction);
}

function setupOptoutTracing() {
	$(document).ready(function () {
		$("#optout input.yes").on("click", function (e) {
			var email_type = $(this).closest('form').data('galabel');
			if (email_type !== "") {
				GA_Event_Trigger("Communication preferences", "Email unsubscribe", email_type);
			}
		});
	});
}


function initProductListTabs() {
	$(document).ready(function () {
		$('.js-product-list-tab').on('click', function (event) {
			event.preventDefault();

			var target = $(this).data('target');
			var $parent = $(this).parent();

			$parent.siblings().removeClass('active');
			$parent.addClass('active');

			$(target).siblings().addClass('u-hidden');
			$(target).removeClass('u-hidden');
		});
	});
}

/*
 * Dynamic list page impression tracking
 */

function setupProductImpressions(impressionClass) {
	$(document).ready(function () {
		// If GA is running, setup impression tracking
		if (typeof ga != 'undefined') {

			var hasScrolled = false;

			var scrollTimer = setInterval(function () {
				if (hasScrolled) {
					hasScrolled = false;
				}
			}, 250);

			$(window).on("load.lsTrackImpressions resize.lsTrackImpressions scroll.lsTrackImpressions", function () {
				if (!hasScrolled) {
					hasScrolled = true;
					var impressionItems = collectProductImpressionsForSend(impressionClass);
					if (impressionItems.length) {
						sendProductImpressions(impressionItems);
					}

					//Cleanup if we have no impressions to send
					if (!$("." + impressionClass).length) {
						$(window).off(".lsTrackImpressions");
						clearInterval(scrollTimer);
					}
				}
			});
		}
	});
}

//Send an enhanced eCommerce impression for an array of products
function sendProductImpressions(productArray) {
	var chunks = chunkArray(productArray, 20);

	for (var j = 0; j < chunks.length; j++) {
		var chunk = chunks[j];

		for (var i = 0; i < chunk.length; i++) {
			ga('ec:addImpression', {
				'id': chunk[i].dataset.gaId,
				'name': chunk[i].dataset.gaName,
				'category': chunk[i].dataset.gaCategory,
				'brand': chunk[i].dataset.gaBrand,
				'list': chunk[i].dataset.gaList,
				'position': chunk[i].dataset.gaPosition,
				'variant': chunk[i].dataset.gaVariant
			});
		}
		GA_Event_Trigger('Enhanced Ecommerce', 'impression', '');
	}
}

//Create an array of products which are visible on the page, but have not had impressions sent
function collectProductImpressionsForSend(impressionClass) {
	var itemsToSend = [];

	$("." + impressionClass).each(function (index) {
		if (isVisibleInViewport(this)) {
			$(this).removeClass(impressionClass);
			itemsToSend.push(this);
		}
	});

	return itemsToSend;
}

// Break down a single array into chunks of max size
function chunkArray(array, maxLength) {
	if (array.length > maxLength) {
		var chunkedArray = [];
		var chunk = [];

		for (var i = 0; i < array.length; i++) {
			if (chunk.length >= maxLength) {
				chunkedArray.push(chunk);
				chunk = [];
			}
			chunk.push(array[i]);
		}
		//Mop up any remaining items in final chunk
		chunkedArray.push(chunk);

		return chunkedArray;
	}
	return new Array(array);
}


function updateProcessorLog(processor, text, hash) {
	if (typeof (processor) === 'undefined' || processor.length === 0 || typeof (text) === 'undefined' || text.length === 0 || typeof (hash) === 'undefined' || hash.length === 0) {
		return false;
	}

	var xmlHttp = getXMLHttp();
	var parameters = "&text=" + encodeURIComponent(text) + "&processor=" + encodeURIComponent(processor) + "&hash=" + encodeURIComponent(hash);
	xmlHttp.open("POST", rootURLProt + "?_g=ex&type=ajaxCart&action=saveProcessorLog&rand=" + Math.random(), true);
	xmlHttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	xmlHttp.send(parameters);
	return xmlHttp;
}
function updateAppointmentRequest($consent, form) {
	var xmlHttp = updateProcessorLog("appointment", $consent.data("data"), $consent.data('hash'));
	if (xmlHttp === false) {
		return false
	}

	xmlHttp.onreadystatechange = function (form) {
		if (xmlHttp.readyState != 0) {
			$('<input>').attr({
				type: 'hidden',
				name: 'confirmRequest',
				value: '1'
			}).appendTo(form);
			form.submit();
		}
	}(form);
}



// Object.entries polyfill
Object.entries || (Object.entries = function (e) { for (var r = Object.keys(e), t = r.length, n = new Array(t); t--;)n[t] = [r[t], e[r[t]]]; return n });

// Object.values polyfill
Object.values || (Object.values = function (r) { var t=[]; for (var e in r) Object.prototype.hasOwnProperty.call(r,e) && t.push(r[e]); return t });

// Object.assign polyfill
"function" != typeof Object.assign && Object.defineProperty(Object, "assign", { value: function (e, t) { "use strict"; if (null == e) throw new TypeError("Cannot convert undefined or null to object"); for (var n = Object(e), r = 1; r < arguments.length; r++) { var o = arguments[r]; if (null != o) for (var c in o) Object.prototype.hasOwnProperty.call(o, c) && (n[c] = o[c]) } return n }, writable: !0, configurable: !0 });


// Promise polyfill
if (typeof window.Promise === 'undefined') {
  deferExternalResource('script', {
    src: '/skins/j/promise-polyfill.js'
  });
}

// Fetch polyfill
if (typeof window.fetch === 'undefined') {
  deferExternalResource('script', {
    src: '/skins/j/fetch-polyfill.js'
  });
}


var DispatchHandler = {
	alternativeProductShow: function (options) {
		$(window).trigger({
			type: 'alternative-product:show',
			options: options
		});
	}
}


var Cookie = {
	all: function () {
		var cookies = document.cookie ? document.cookie.split('; ') : [];
		var data = {};

		cookies.forEach(function (item, index) {
			var parts = item.split('=');
			var name = parts[0];
			var cookie = parts.slice(1).join('=');

			data[name] = cookie;
		});

		return data;
	},
	get: function (name) {
		var cookies = Cookie.all();

		return cookies[name] || null;
	},
	set: function (key, value, attributes) {
		attributes = attributes || {};

		if (typeof attributes.expires === 'number') {
			attributes.expires = new Date(new Date() * 1 + attributes.expires * (24 * 60 * 60 * 1000));
		}

		var expires = attributes.expires ? attributes.expires.toUTCString() : '';

		attributes = Object.assign(attributes, {
			expires: expires,
			path: '/',
			samesite: 'Lax'
		});

		attributes = Array.prototype.map.call(Object.entries(attributes), function (item) {
			return item.join('=');
		});

		attributes.unshift([key, value].join('='));
		document.cookie = attributes.join('; ')
	},
	remove: function (key, attributes) {
		attributes = attributes || {};

		Cookie.set(key, '', Object.assign(attributes, {
			expires: -1
		}));
	}
};


var DateTime = {
	create: function (options) {
		return moment(options);
	},
	now: function () {
		return moment();
	},
	today: function () {
		return moment();
	},
	yesterday: function () {
		return moment().subtract(1, 'day');
	},
	tomorrow: function () {
		return moment().add(1, 'day');
	},
	parse: function (value) {
		return moment(value);
	},
	format: function (pattern, date) {
		var locale = document.querySelector('html').lang;
		pattern = pattern || DateTime.pattern(locale);
		date = date || DateTime.today();

		// Set support for internationalization
		if (locale !== '') {
			date.locale(locale);
		}

		return date.format(pattern);
	},
	pattern: function (locale) {
		var pattern = 'dddd, D MMMM YYYY';

		switch (locale) {
			case 'de-DE':
				pattern = 'dddd, D. MMMM YYYY';
				break;

			case 'it-IT':
				// pattern = '';
				break;

			case 'fr-FR':
				// pattern = '';
				break;
		}

		return pattern;
	}
};


var UrlHelper = function() {
  this.query = window.location.search;
  this.params = this._parseParams();
};

UrlHelper.prototype._getAllParams = function(query) {
  query = query.replace(/^.+?/, '');

  if (query === '') {
    return {};
  }

  var params = {};
  query = query.split('&');

  query.forEach(function (item, index) {
    var parts = item.split('=');
    var key = decodeURIComponent(parts[0]);
    var value = decodeURIComponent(parts[1]) || null;

    params[key] = value;
  });

  return params;
};

UrlHelper.prototype._parseParams = function() {
  if (typeof URLSearchParams === 'undefined') {
    var params = this._getAllParams(this.query);

    this.get = function (name) {
      return params[name] || null;
    };

    return this;
  }

  return new URLSearchParams(this.query);
};

UrlHelper.prototype.getParams = function() {
  throw new Error('Not implemented');
};

UrlHelper.prototype.getParam = function(name) {
  return this.params.get(name);
};

var TemplateHandler = {
	_normalizeKey: function (key, reference) {
		reference = reference || '';
		reference = reference.toString();

		if (reference !== '') {
			key = reference + key + reference;
		}

		return '{' + key + '}';
	},

	parse: function (template, data, reference) {
		template = template || '';
		template = template.toString();
		data = data || {};

		var self = this;

		$.each(data, function (key, value) {
			key = self._normalizeKey(key, reference);
			var pattern = new RegExp(key, 'gi');

			template = template.replace(pattern, value);
		});

		return template;
	}
};

function isTouchscreen() {
	return 'ontouchstart' in document.documentElement;
}


function isEmailAddress(value) {
	return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
}


// Detect touch devices
function initDetectTouch() {
	if (isTouchscreen()) {
		$('body').addClass('touch');
	}
}


// Show warning for the old browsers
function initBrowserWarning() {
	if (isIE()) {
		var template = $('#browser-warning').html();

		$('body').prepend(template);
	}
}


function isIE() {
  var ua = window.navigator.userAgent;
  var matches = ua.match(/MSIE\s?([\d.]+)/);

  if (!matches || parseInt(matches[1], 10) !== 10) {
    return false;
  }

  return true;
}

function isIE11() {
	var ua = window.navigator.userAgent;
	var match = ua.match(/Trident\/7\./);

	return !!match;
}

function browserIsChrome() {
	var ua = window.navigator.userAgent;
	var isChrome = /chrom(e|ium)/.test(ua.toLowerCase());
	var vendorName = window.navigator.vendor;

	if (isChrome && vendorName === "Google Inc.") {
		return true;
	}

	return false;
}


function isSafari() {
  // Check if the browser is using Chrome engine
  if (browserIsChrome()) {
    return false;
  }

  var ua = window.navigator.userAgent;
  var matches = ua.match(/AppleWebKit|Safari/);

  if (!matches) {
    return false;
  }

  return true;
}


function isMacOS () {
  var ua = window.navigator.userAgent;
  var matches = ua.match(/Mac\s?OS/);

  if (!matches) {
    return false;
  }

  return true;
}


// CSS support for old browsers
function initCSSFallback() {
	if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') {
		$('body').addClass('fallback');
	}
}


/*
 * Load an external resource using "defer" or "async" process
 *
 * Retry script execution if the specified resource is not available.
 * @see "retryScriptExecution" function
 *
 * @param {string} tag      - The HTML tag to create (script, link or another element)
 * @param {object} options  - A list of keys and values consisting of attributes for the HTML tag
 * @param {object} callback - A list of keys and values for the callback
 *    key {string} lookup   - The reference key to search into the window object
 *    key {string} method   - A function to be executed upon completion
 *
 * @return {boolean} - Used only as control value to interrupt script execution
 */
function deferExternalResource(tag, options, callback) {
  options = options || {};
  callback = callback || {};

  if (tag === 'style') {
    tag = 'link';

    options.rel = 'stylesheet';
    options.type = 'text/css';
  }

  var head = document.getElementsByTagName('head')[0];
  var element = document.createElement(tag);

  element = Object.assign(element, options);
  head.appendChild(element);

  if (!Object.keys(callback).length) {
    return false;
  }

  retryScriptExecution(callback.lookup, callback.method);
}


/*
 * Retry script execution if a resource is not available
 *
 * @param {string} lookup   - The reference key to search into the window object
 * @param {object} callback - A function to be executed upon completion
 * @param {int}    attempts - The number of attempts to retry script execution.
 *    Default set to 10
 * @param {int}    delay    - The delay between attempts in miliseconds.
 *    Default set to 500
 *
 * @return {boolean} - Used only as control value to interrupt script execution
 */
function retryScriptExecution(lookup, callback, attempts, delay) {
  if (!lookup || typeof callback !== 'function') {
    return false;
  }

  attempts = attempts || 10;
  delay = delay || 500;

  var i = 1;
  var interval = setInterval(function () {
    if (typeof window[lookup] !== 'undefined') {
      callback();

      clearInterval(interval);
    }

    // Failsafe interval loop
    if (i >= attempts) {
      clearInterval(interval);
    }

    i++;
  }, delay);
}


// Switch content under tabs
function initListPageNavTabs() {
	if (!$('.js-list-page__nav-tab-link').length) {
		return false;
	}

	$('.js-list-page__nav-tab-link').on('click', function (event) {
		event.preventDefault();

		var target = $(this).data('target');
		var $parent = $(this).parent();

		// Manage active tab
		$parent.siblings().removeClass('active c-list-page__nav-tab-item--is-active');
		$parent.addClass('active c-list-page__nav-tab-item--is-active');

		// Manage active content
		if ($(target).length) {
			var index = $parent.index();
			var $tab = $(target).eq(index);

			$tab.siblings().removeClass('active c-list-page__tab-panel--is-active');
			$tab.addClass('active c-list-page__tab-panel--is-active');
		}
	});
}

function initCooperSwitch() {
	if (!$('#cooperSwitchTcsShow').length) {
		return false;
	}

	$("#cooperSwitchTcsShow").on("click", function (event) {
		event.preventDefault();
		$(this).hide();
		$("#cooperSwitchTcs").slideDown();
	});

	$("#cooperSwitchTcsHide").on("click", function (event) {
		event.preventDefault();
		$("#cooperSwitchTcsShow").show();
		$("#cooperSwitchTcs").slideUp();
	});

	$("#cooperAcceptOffer").on("click", function (event) {
		event.preventDefault();
		applyWaitingOverlay("cooperSwitchContainer");
		var xmlHttp = getXMLHttp();

		xmlHttp.onreadystatechange = function () {
			if (xmlHttp.readyState == 4) {
				removeWaitingOverlay("cooperSwitchContainer");
				if (xmlHttp.responseText !== 'ok') {
					showSwitchError(xmlHttp.responseText);
					return false;
				}

				$("#cooperBoxFirst").fadeOut(function () {
					$("#cooperBoxSecond").fadeIn();
				});
			}
		}

		xmlHttp.ontimeout = function () {
			showSwitchError("timeout");
		}

		xmlHttp.open("GET", siteroot + "?_g=ex&type=ajaxCart&action=setFreeGiftOptin&optin=1&rand=" + Math.random(), true);
		xmlHttp.timeout = 5000;
		xmlHttp.send(null);
	});
}

function showSwitchError(msg) {
	$("#switchErrorMessage").show();
	GA_Event_Trigger("Checkout", "Live 1 Day error - " + msg, "CooperVision support");
}

// Manage Google Analytics events
function initAnalyticsEvent() {
	var key = 'ga-event';
	var $elements = $('[data-' + key + ']');

	if (!$elements.length) {
		return false;
	}

	$elements.each(function (index, element) {
		var $element = $(element);
		var data = $element.data(key);

		if (typeof data.event !== 'undefined' && data.event !== '') {
			// Attach a JS event to the element
			$element.on(data.event, function () {
				GA_Event_Trigger(data.category, data.action, data.label);
			})

			return true; // continue
		}

		GA_Event_Trigger(data.category, data.action, data.label);
	});
}


// Automatically prefill the prescription details
function initPrefillPrescription() {
	var key = 'prefill-prescription';
	var $element = $('[data-' + key + ']');

	if (!$element.length) {
		return false;
	}

	var data = $element.data(key);

	if (typeof data === 'undefined' || data === '') {
		return false;
	}

	var $units = $('input[name="units"]', $element);
	var $quantity = $('select[name="quan"]', $element);

	// Select prescription options
	Object.values(data.prescription).forEach(function (item, index) {
		var eye = index + 1;
		var name = 'productOptions';
		name += eye > 1 ? eye : '';
		var $option = $('select[name="' + name + '[]"]', $element);

		$option.each(function (index, element) {
			if (typeof item[index] !== 'undefined') {
				$(element).val(item[index]);
			}
		});

		checkLiveStockLevel(rootURL, eye);
	});

	// Select between both eyes and one eye options
	$units.each(function (index, element) {
		if (parseInt(element.value) === data.items) {
			$(element).trigger('click');

			return false; // break
		}
	});

	// Select product quantity
	$quantity.val(data.quantity);
}


// Add a modifier class to product purchase container if there's insufficient space for Sticky.
function setupPurchaseBoxStickiness() {
	if (!$('.js-product-purchase-container').length || !$('.js-product-purchase-button').length) {
		return false;
	}

	$(window).on('load resize orientationchange', function () {
		var $container = $('.js-product-purchase-container');
		var $button = $('.js-product-purchase-button');
		var requiredSpace = (($button.offset().top + $button.outerHeight()) - $container.offset().top) + 30;
		var nonStickyClass = 'c-product-purchase-container--non-sticky';

		if ($(window).height() < requiredSpace) {
			$container.addClass(nonStickyClass);
		} else {
			$container.removeClass(nonStickyClass);
		}
	});
}


// Display the shopping cart summary on hover
// Show and keep the summary open until the mouse left the shopping cart link and summary list
function initCartSummaryRegular() {
	if (!$('.js-shopping-cart-list').length) {
		return false;
	}

	var $link = $('.js-shopping-cart-link');
	var $list = $('.js-shopping-cart-list');
	var timeout;

	// Attach event handler on mouse enter
	$link.on('mouseenter', function () {
		if (!$list.hasClass('open')) {
			$list.addClass('open');
		}

		// Clear any previous timeout events
		clearTimeout(timeout);

		// Dettach previous event handlers
		$list.off('mouseenter');
		$list.off('mouseleave');


		// Attach event handler on mouse enter
		$list.on('mouseenter', function () {
			// Clear any previous timeout events
			clearTimeout(timeout);
		});


		// Attach event handler on mouse leave
		$list.on('mouseleave', function () {
			// Allow user time to respond when exiting the area
			timeout = setTimeout(function () {
				if ($list.hasClass('open')) {
					$list.removeClass('open');
				}
			}, 500);
		});
	});


	// Attach event handler on mouse leave
	$link.on('mouseleave', function () {
		// Allow user time to respond when exiting the area
		timeout = setTimeout(function () {
			if ($list.hasClass('open')) {
				$list.removeClass('open');
			}
		}, 250);
	});
}


// Display the shopping cart summary on tap (touch devices)
function initCartSummaryTouch() {
	if (!$('.js-shopping-cart-list').length) {
		return false;
	}

	var listClassName = 'js-shopping-cart-list';
	var $link = $('.js-shopping-cart-link');
	var $list = $('.' + listClassName);
	var isWindow = false;

	// Attach event handler on mouse click
	$link.on('click', function (event) {
		event.preventDefault();
	});


	// Attach event handler on touch start
	$link.on('touchstart', function () {
		isWindow = false;
	});


	// Attach event handler on touch end
	$link.on('touchend', function () {
		// Change the state of the shopping cart summary
		if (!isWindow) {
			$list.toggleClass('open');
		}
	});


	// Attach event handler when items outside the shopping cart summary are selected
	$(window).on('touchstart', function (event) {
		var $target = $(event.target);
		var $linkParent = $target.parents($link.selector);

		// Ignore interaction from shopping cart link
		if ($linkParent.length) {
			return false;
		}

		// Ignore the shopping cart summary
		if ($target.hasClass(listClassName)) {
			return false;
		}

		// Manage the state of shopping cart summary
		var $parent = $target.parents($list.selector);

		if (!$parent.length && $list.hasClass('open')) {
			$list.removeClass('open');

			isWindow = true;
		}
	});
}


function mockElement($element) {
	if (!$element.length) {
    return false;
  }

	var $clone = $element.clone();
	var tag = $clone.data('tag');
	var $replacement = $('<' + tag + '>');
	var attributes = {};

	var customAttributes = {
		'inlinestyle': 'style',
		'classname': 'class'
	};

	// Prevent fallback content being shown on the page
	$('fallback', $clone).remove();
	var contents = $clone.html();

	$.each($clone.get(0).attributes, function (index, attribute) {
		var name = attribute.name;

		if (name === 'data-tag') {
			return true; // continue
		}

		if (customAttributes.hasOwnProperty(name)) {
			name = customAttributes[name];
		}

		attributes[name] = attribute.value;
	});

	$replacement.attr(attributes);
	$replacement.append(contents);

	return $replacement;
}


function OptanonWrapper() {
	if ($('body').has('.cookiepro-overlay').length === 0 && document.cookie.indexOf('OptanonAlertBoxClosed') === -1) {
		var overlay = document.createElement('div');
		overlay.classList.add('cookiepro-overlay');
		$('body').prepend(overlay);

		$('.optanon-allow-all.accept-cookies-button')
			.on('click', function(){
				$(overlay).hide();
			});
	}

	// The cookie settings do not update on click so window.OptanonActiveGroups has not yet updated the data.
	// So we reload this page to fire the onload check instead.
	$('.optanon-save-settings-button').on('click', function () {
		window.location.reload();
	});

	if (typeof MarketingEvents !== 'undefined') {
		MarketingEvents.handle();
	}

	_initCookieproAsyncCallback();
}


function getConsentGroups() {
  var groups = window.OptanonActiveGroups || '';
  groups = groups.split(',');

  if (!groups.length) {
    return [];
  }

  var filtered = [];

  groups.forEach(function (item, index) {
    if (item === '') {
      return true; // continue
    }

    filtered.push(item);
  });

  return filtered;
}


function initCookieSettings() {
  var $cookies = $('cookiepro');
  var consentGroups = getConsentGroups();

  if (!$cookies.length || !consentGroups.length) {
    return false;
  }

  $cookies.each(function (index, element) {
    var $element = $(element);
    var rendered = $element.data('rendered') || '';

    if (rendered === '') {
      // Set timestamp for the rendered element
      $element.data('rendered', Date.now().toString());
    } else {
      // Skip a previously rendered element
      return true; // continue
    }

    var $target = $element;
    var id = $element.data('id') || 0;

    if (consentGroups.indexOf(id.toString()) === -1) {
      $target = $('fallback', $element);
    }

    $element.after(mockElement($target));
  });
}


function initDataCapture() {
	var key = 'capture';
	var $element = $('[data-' + key + ']');
	var windowWidth = $(window).width();

	if (!$element.length) {
		return false;
	}

	var DataCapture = {
		setCookie: function () {
			// Hide the popup for the next 30 days
			Cookie.set('DataCapture', 'hidden', {
				expires: 30
			});
		},

		handlePopup: function ($popup) {
			var cookie = Cookie.get('DataCapture');

			if (cookie === 'hidden') {
				return false;
			}

			// Show popup when the user tries to leave browser page
			$(document).mouseleave(function (event) {
				cookie = Cookie.get('DataCapture');

				if (cookie !== 'hidden') {
					// If mouse leaves the top of the browser viewport
					if (event.clientY <= 1 && !$popup.hasClass('show')) {
						setTimeout(function () {
							$popup.addClass('show');
						}, 300);
					}
				}
			});
		},

		hidePopup: function ($popup, setCookie) {
			setCookie = setCookie || false;
			$popup.removeClass('show');

			if (setCookie === true) {
				DataCapture.setCookie();
			}
		},

		handleDismiss: function (event) {
			event.preventDefault();

			var target = $(this).data('dismiss');
			var type = $(this).data('type');
			var setCookie = type !== 'overlay';

			DataCapture.hidePopup($(target), setCookie);
		},

		handleRequiredField: function (event) {
			var $field = $(this);
			var value = $.trim($field.val());
			var $error = $field.parent().find('error');
			var data = $field.data('required');
			var type = $field.attr('type');
			var template = '<error>{message}</error>';
			var message = '';

			if (value === '') {
				message = data.empty;
			}

			if (type === 'email') {
				if (value !== '' && !isEmailAddress(value)) {
					message = data.invalid;
				}
			}

			if (message !== '') {
				if (!$error.length) {
					var element = template
						.replace('{message}', message);
					var $error = $(element);

					$field.after($error);
				} else {
					$error.html(message);
				}

				$field.addClass('error');
				$error.addClass('show');
			} else {
				$field.removeClass('error');
				$error.removeClass('show');
			}
		},

		handleForm: function (event) {
			event.preventDefault();

			var self = this;
			var $parent = $(this).closest('[data-' + key + ']');
			var $confirmation = $('[data-confirmation]', $parent);
			var type = $parent.data(key);
			var data = $(this).serializeArray();
			var formData = $(this).data('form');
			var filtered = {};

			data.forEach(function (item, index) {
				filtered[item.name] = $.trim(item.value);
			});

			// Extend data values
			filtered = Object.assign(filtered, {
				wording: formData,
				_g: 'ex',
				action: 'saveDataCapture',
				type: type,
				rand: Math.random()
			});

			if (filtered.email === '' || !isEmailAddress(filtered.email)) {
				$('input[name="email"]', self).trigger('blur');

				return false;
			}

			$.ajax({
				url: rootURL,
				method: 'POST',
				dataType: 'json',
				data: filtered,
				beforeSend: function () {
				},
				success: function (data, status, xhr) {
					if (data === true) {
						var source = (type === 'popup') ? 'Pop-up' : 'Homepage';
						var event = {
							category: 'Data Capture',
							action: 'Submit',
							label: source + ' Banner'
						};

						GA_Event_Trigger(event.category, event.action, event.label);

						DataCapture.setCookie();

						// Display confirmation message
						$confirmation.addClass('show');

						// Clear form data
						self.reset();
					}
				},
				error: function (xhr, status, error) {
				}
			});
		}
	};

	$('[data-dismiss]', $element).on('click', DataCapture.handleDismiss);
	$('[data-required]', $element).on('blur keyup', DataCapture.handleRequiredField);

	$('form', $element).on('submit', DataCapture.handleForm);

	$element.each(function (index, element) {
		var type = $(element).data(key);

		if (type === 'popup') {
			var target = $(element).data('dismiss');

			if (target && target !== '') {
				$(element).on('click', DataCapture.handleDismiss);
			}

			DataCapture.handlePopup($(element));
		}
	});

	if (windowWidth > 767) {
		$('media-element', $element).each(function (index, media) {
			var $media = $(media);

			$media.after(mockElement($media));

			var video = $('video', $element).get(0);
			video = video || {}; // Fallback
			video.volume = 0;

			if (video.paused) {
				var playPromise = video.play();

				if (typeof playPromise !== 'undefined') {
					playPromise.then(function () {
						// Nothing to do
					})
						.catch(function () {
							// Video playback failed
							// Suppress error in browser
						});
				}
			}
		});
	}
}

function initAltProduct() {
	var key = 'alternative-product';
	var $element = $('[data-' + key + ']');

	if (!$element.length) {
		return false;
	}

	var AltProduct = {

		showPopup: function (event) {
			var options = event.options || {};

			if (typeof options.redirect !== 'undefined' && options.redirect !== '') {
				$('[data-action]', $element).attr("href", decodeURIComponent(options.redirect));
			}

			$element.addClass('show');
		},

		hidePopup: function ($popup) {
			$popup.removeClass('show');
		},

		handleDismiss: function (event) {
			event.preventDefault();

			var target = $(this).data('dismiss');

			AltProduct.hidePopup($(target));
		},

		appendPopup: function () {
			$element.appendTo('body');
		}
	};

	$('[data-dismiss]', $element).on('click', AltProduct.handleDismiss);

	$(window).on("alternative-product:show", AltProduct.showPopup);

	AltProduct.appendPopup();
}

function initPanelGroup() {
	var key = 'panel-group';
	var $element = $('[data-' + key + ']');

	if (!$element.length) {
		return false;
	}

	var Handler = {
		togglePanel: function (event) {
			var $parent = $(this);
			var target = $parent.data('toggle');
			var $target = $parent.next(target);

			// Find target element within parent
			if (!$target.length) {
				$target = $(target, $parent);
			}

			if (!$target.length) {
				return false;
			}

			$(target).removeClass('show');
			$target.toggleClass('show');
		}
	};

	$('[data-toggle]', $element).on('click', Handler.togglePanel);
}


function liveChatPrescriptionHelp() {
	var openLiveChat = function (event) {
		GA_Event_Trigger('Product', 'click', 'prescription live help');
		event.preventDefault();
		var custom_variables = [
			{ name: 'Reason', value: 'Needs prescription advice' }
		];
		LC_API.set_custom_variables(custom_variables);
		LC_API.open_chat_window();
	};

	var doc_link = document.querySelector('.js-help-product-link');

	if (!doc_link) {
		return false;
	}

	var site_doc_prescription_help = doc_link.getAttribute('title');
	var live_chat_prescription_help = doc_link.getAttribute('data-live-chat-title');

	if (live_chat_prescription_help === '') {
		return false;
	}

	if (LC_API.agents_are_available()) {
		doc_link.innerHTML = live_chat_prescription_help;
		doc_link.addEventListener('click', openLiveChat, false);
	}

	LC_API.on_chat_state_changed = function (data) {
		if (data.state === 'offline') {
			doc_link.innerHTML = site_doc_prescription_help;
			doc_link.removeEventListener('click', openLiveChat);
		} else if (data.state === 'online_for_chat') {
			doc_link.innerHTML = live_chat_prescription_help;
			doc_link.addEventListener('click', openLiveChat, false);
		}
	}
}

function initPlanoShortcut() {
	$plano_shortcut = $("#plano_shortcut");
	if (!$plano_shortcut.length) {
		return false;
	}

	$plano_shortcut.on("click", function () {
		handlePlanoShortcutSelection(this);
	});

	handlePlanoShortcutSelection($plano_shortcut);
}

function handlePlanoShortcutSelection(checkbox) {
	if ($(checkbox).is(":checked")) {
		$(".js-product-option-container").not("[data-colour-option]").hide();
		$("[data-plano-option]").prop("selected", "selected");
	} else {
		$("[data-default-option]").prop("selected", "selected");
		$(".js-product-option-container").show();
	}
}


function initZendeskChat() {
  // Check for Zendesk script presence, and for a lang value set
  var key = 'ze-chat';
  var lang = 'ze-lang';
  var $element = $('[data-' + key + ']');

  if (!$element.length || !$element.data(lang)) {
    return false;
  }

  var callback = function () {
    var value = $element.data(lang);

    window.zE('webWidget', 'setLocale', value);
  };

  retryScriptExecution('zE', callback, 20, 250);
}

function initZendeskChatActions() {
  var hashKey = '#live-chat';
  var key = 'zendesk-chat-trigger';
  var $element = $('[data-' + key + ']');
  var disabledClass = 'c-link-is-inactive';

  var handleEvent = function (action) {
    var allowedActions = [
      'open',
      'close'
    ];

    if (typeof action === 'object') {
      action.preventDefault();

      var $element = $(action.currentTarget);
      action = $element.data(key);
    }

    if (allowedActions.indexOf(action) === -1) {
      return false;
    }

    window.zE('webWidget', action);
  };

  var callback = function () {
    var hash = window.location.hash;

    if (hash.indexOf(hashKey) !== -1) {
      handleEvent('open');
    }

    // Attach click events to DOM elements
    $element.on('click', handleEvent);

    // Return links to their initial state
    $element.removeClass(disabledClass);
  };

  retryScriptExecution('zE', callback, 20, 250);
}


function initViewInvoice() {
	var key = 'view-invoice';
	var $elements = $('[data-' + key + ']');

	if (!$elements.length) {
		return false;
	}

	var Handler = {
		manageAlert: function ($element) {
			var $alert = $('[role="alert"]', $element);

			if (!$alert.length) {
				return false;
			}

			// Bring alert message on the main view
			$('html, body').animate({
				scrollTop: $element.offset().top - 10
			}, 1000);

			// Hide alert message after 15 seconds
			setTimeout(function () {
				$alert.fadeOut(300, function () {
					$alert.remove();
				});
			}, 15000);
		},
		manageLink: function (event) {
			var $element = $(event.currentTarget);
			var href = event.currentTarget.getAttribute('href');

			// Mark element as active
			$element.addClass('active');

			// Prevent Safari desktop to freeze JS execution on URL change
			if (isMacOS() && isSafari()) {
				if (href !== '' || href !== '#') {
					event.preventDefault();

					// Manually redirect to the target URL
					setTimeout(function () {
						window.location = href;
					}, 300);
				}
			}

			// Return to the original statte after 3 seconds
			setTimeout(function () {
				$element.removeClass('active');
			}, 3000);
		}
	}

	$elements.each(function (index, element) {
		var $element = $(element);
		var type = $element.data(key);

		switch (type) {
			case 'alert':
				Handler.manageAlert($element);
				break;

			case 'link':
				$element.on('click', Handler.manageLink);
				break;

			default:
				break;
		}
	});
}


function initTradeDoubler() {
  var tduid = (new UrlHelper).getParam('tduid') || '';

  if (tduid === '') {
    return false;
  }

  var consentGroup = '4';
  var consentGroups = getConsentGroups();

  if (consentGroups.indexOf(consentGroup) === -1) {
    return false;
  }

  var cookieName = 'TradeDoubler';

  if (Cookie.get(cookieName)) {
    return false;
  }

  // Set a cookie for the next 30 days
  Cookie.set(cookieName, tduid, {
    expires: 30
  });
}

function initAbandonmentTracker() {
	window.isPrescriptionAbandom = false;
	window.isBasketAbandom = false;

	if (typeof window.hj !== 'undefined') {
		window.addEventListener('beforeunload', function (e) { 
			if (!navigator.userAgent.indexOf('Firefox') > 0) {
				e.preventDefault();
			}
			
			if(window.isPrescriptionAbandom) {
				hj('tagRecording', ['prescription-abandonment']);
			} else if(window.isBasketAbandom) {
				hj('tagRecording', ['adding-to-basket-abandonment']);
			}
		});
	}
}

/*
 * Load functionality dependent on Cookiepro consent groups
 *
 * Cookiepro loads in asynchronous mode and certain consent groups are not available on page load but at a later stage.
 * Consider the functionality of any scripts that use event bindings and are added in $(document).ready() and this callback function.
 * Duplicated event bindings may occur.
 */
function _initCookieproAsyncCallback() {
  initCookieSettings();
  initTradeDoubler();
}

/*
 * Check for load balancer cookies set as part of Split Legacy vs SPA test
 * Return value of ls_lb_aid cookie if it and ls_lb_uid cookies are present, otherwise return empty string
 */
function getSplitTreatmentFromCookies() {
	var treatment = '';
	var lbUserCookie = Cookie.get('ls_lb_uid');
	var lbTreatmentCookie = Cookie.get('ls_lb_aid');
	if(lbUserCookie && lbTreatmentCookie) {
		treatment = lbTreatmentCookie;
	}

	return treatment;
}

function markUserTypeSet() {
	$.ajax({
		url: rootURLProt + '?_g=ex&type=markUserTypeSet',
		method: 'POST',
		async: true
	});
}

var AuthorizationHandler = {
	'tokenName': 'jtoken',
	getToken: function() {
		return Cookie.get(this.tokenName);
	},
};


$(document).ready(function () {
	initCookieSettings();
	initDetectTouch();
	initBrowserWarning();
	initCSSFallback();
	initListPageNavTabs();
	initAnalyticsEvent();
	initPrefillPrescription();
	initPanelGroup();
	initDataCapture();
	initAltProduct();
	setupPurchaseBoxStickiness();
	capturePlusInit();
	initPca();
	initCooperSwitch();
	initPlanoShortcut();
	initZendeskChat();
	initZendeskChatActions();
	initViewInvoice();
  	initTradeDoubler();
	initAbandonmentTracker();

	// Manage touch devices
	if (isTouchscreen()) {
		initCartSummaryTouch();
	} else {
		initCartSummaryRegular();
	}
});
